<template>
  <div id="detail" class="hotel_container">
    <el-form :inline="true" :model="dataForm" :rules="bookingRules" ref="dataForm" label-position="top" class="demo-form-inline">
      <Loading :loading="submitLoading" />
      <div class="hotel_container_panel">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="height: 3.7rem; line-height: 5rem">
          <el-breadcrumb-item :to="{ name: 'orderList' }">{{ $t("MANUAL.ORDERMANAGE") }}
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{
            $t("MANUAL.MANUALORDER")
          }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div id="nav2">
          <div style="background-color: #ffffff">
            <el-row :gutter="10" class="row_sty">
              <el-col :span="24" style="padding-left: 0; padding-top: 1rem">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">{{
                    $t("CONFIRMATION.TITLE5")
                  }}</span>
                  <el-button size="default" class="add-guest-btn" style="margin-left:50px;"  @click="openManualOrderList()">{{$t("MANUAL.MANUALORDERLIST")}}</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CLIENT')" prop="customer.customerName" class="form-label-field">
                  <el-input @click="showClientNamePop" readonly v-model="dataForm.customer.customerName" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CONTACTNAME') + ':'" prop="contact.contactName" class="form-label-field">
                  <el-input @click="showContactNamePop" readonly v-model="dataForm.contact.contactName" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CONTACTMOBILE')" prop="contact.contactMobile" class="form-label-field">
                  <el-input v-model="dataForm.contact.contactMobile" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CONTACTEMAIL')" prop="contact.contactEmail" class="form-label-field">
                  <el-input v-model="dataForm.contact.contactEmail" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div>
          <div style="background-color: #ffffff;padding-bottom: 1rem;">
            <el-row :gutter="10" class="row_sty">
              <el-col :span="24" style="padding-left: 0; padding-top: 1rem">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">{{$t("MANUAL.SELECTGUEST")}}</span>  
                  <el-checkbox style="margin-left:10px;color: #FF694B;" @change="ChangeGuest()">{{$t("USERDIALOG.GUEST")}}</el-checkbox>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.GUESTNAME') + ':'" prop="traveler.travelerName" class="form-label-field" style="width:80%;">
                  <el-input :readonly="changeGuestCheckBox" v-model="dataForm.traveler.travelerName">
                    <template #append>
                      <el-button style="margin:0;" @click="showTravelerNamePop('guest')" v-if="changeGuestCheckBox">
                        <el-icon><Search /></el-icon>
                      </el-button>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.MOBILE')" prop="traveler.mobile" class="form-label-field">
                  <el-input v-model="dataForm.traveler.mobile" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.EMAIL')" prop="traveler.email" class="form-label-field">
                  <el-input v-model="dataForm.traveler.email" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" v-if="dataForm.traveler.showIdNumber">
                <el-form-item
                  :label="$t('cardTypeDialog.idNumber')"
                  prop="traveler.cardTypeNumber"
                  class="form-label-field"
                  :rules="[{required: true,message: this.$t('cardTypeRules.IdCardEmpty'),trigger: ['change']}]"
                >
                  <div style="display: flex; width: 100%; gap: 10px; align-items: center;">
                    <el-select v-model="dataForm.traveler.cardType" :disabled="dataForm.traveler.cardTypeSelectDisabled">
                      <el-option v-for="item in cardTypeOption" 
                        :key="item.value" 
                        :label="item.label" 
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input readonly v-model="dataForm.traveler.cardTypeNumber" :disabled="false" auto-complete="off" type="text"></el-input>
                    <el-button @click="openCardTypeDialog" :disabled="dataForm.traveler.cardTypeButtonDisabled" :class="{ 'editCardTypeButtonStyle': !dataForm.traveler.cardTypeButtonDisabled }">{{ $t("INVOICINGBUTTON.DEIT") }}</el-button>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" v-show="isCostCenterShow">
                <el-form-item label="成本中心" class="form-label-field">
                  <el-select 
                      v-model="dataForm.costCenterid" 
                      @change="CostCenterChange($event)"
                      v-el-select-loadmore="CostCenterloadMore(costCenterrangeNumber)"
                      filterable :filter-method="filterMethod" 
                      @visible-change="visibleChange"
                      :disabled="isCostCenterEdit">
                        <el-option :key="0" :label="$t('MANUAL.SELECTPLACEHOLDER')" :value="0"></el-option>
                        <el-option
                          v-for="item in costCenteroptions.slice(0, costCenterrangeNumber)"
                          :key="item.id"
                          :label="getCostCenterValue(item)"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" v-if="this.dataForm.customer.ordApprovalType=='1'">
                <el-form-item :label="$t('MANUAL.APPROVEDTRIPS')" class="form-label-field">
                  <el-input @focus="showApprovedTripsPop" readonly v-model="dataForm.approvedTrips.systemTripNo" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size" v-if="dataForm.showLinker">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CONTACTNAME') + ':'" prop="contact.contactName" class="form-label-field" style="width:80%;">
                  <el-input v-model="dataForm.traveler.linkerName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CONTACTMOBILE')" prop="traveler.mobile" class="form-label-field">
                  <el-input v-model="dataForm.traveler.linkerMobile" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CONTACTEMAIL')" prop="traveler.email" class="form-label-field">
                  <el-input v-model="dataForm.traveler.linkerEmail" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="showButton">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-button type="warning" class="search-btn" style="width: 120px;margin: 0 5%; line-height: 2;" @click="showOtherGuest()">{{ dataForm.isShowOtherGuest? $t("ORDERLIST.DELETE"):$t("MANUAL.ADDOTHERGUESTNAME") }}</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size" v-if="dataForm.isShowOtherGuest">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.OTHERGUESTNAME')" prop="traveler.travelerName" class="form-label-field" style="width:80%;">
                  <el-input :readonly="changeGuestCheckBox" v-model="dataForm.bookingFormOther.name">
                    <template #append>
                      <el-button style="margin:0;" @click="showTravelerNamePop('other')" v-if="changeGuestCheckBox">
                        <el-icon><Search /></el-icon>
                      </el-button>
                    </template>
                  </el-input>
                </el-form-item>
                <!-- <el-form-item :label="$t('MANUAL.OTHERGUESTNAME')" prop="bookingFormOther.name" class="form-label-field">
                  <el-input @focus="showTravelerNamePop('other')" readonly v-model="dataForm.bookingFormOther.name" class="myinput_inner"></el-input>
                </el-form-item> -->
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.MOBILE')" prop="bookingFormOther.mobile" class="form-label-field">
                  <el-input v-model="dataForm.bookingFormOther.mobile" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.EMAIL')" prop="bookingFormOther.email" class="form-label-field">
                  <el-input v-model="dataForm.bookingFormOther.email" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" v-if="dataForm.bookingFormOther.showIdNumber">
                <el-form-item
                  :label="$t('cardTypeDialog.idNumber')"
                  prop="bookingFormOther.cardTypeNumber"
                  class="form-label-field"
                  :rules="[{required: true,message: this.$t('cardTypeRules.IdCardEmpty'),trigger: ['change']}]"
                >
                  <div style="display: flex; width: 100%; gap: 10px; align-items: center;">
                    <el-select v-model="dataForm.bookingFormOther.cardType" :disabled="dataForm.bookingFormOther.cardTypeSelectDisabled">
                      <el-option v-for="item in cardTypeOption" 
                        :key="item.value" 
                        :label="item.label" 
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input readonly v-model="dataForm.bookingFormOther.cardTypeNumber" :disabled="false" auto-complete="off" type="text"></el-input>
                    <el-button @click="openOtherCardTypeDialog" :disabled="dataForm.bookingFormOther.cardTypeButtonDisabled" :class="{ 'editCardTypeButtonStyle': !dataForm.bookingFormOther.cardTypeButtonDisabled }">{{ $t("INVOICINGBUTTON.DEIT") }}</el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size" v-if="dataForm.showLinker && dataForm.isShowOtherGuest">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CONTACTNAME') + ':'" prop="contact.contactName" class="form-label-field" style="width:80%;">
                  <el-input v-model="dataForm.bookingFormOther.linkerName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CONTACTMOBILE')" prop="bookingFormOther.mobile" class="form-label-field">
                  <el-input v-model="dataForm.bookingFormOther.linkerMobile" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CONTACTEMAIL')" prop="bookingFormOther.email" class="form-label-field">
                  <el-input v-model="dataForm.bookingFormOther.linkerEmail" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div id="nav3">
          <div style="background-color: #ffffff">
            <el-row :gutter="10" class="row_sty">
              <el-col :span="24" style="padding-left: 0; padding-top: 1rem">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">{{
                    $t("MANUAL.ORDERINFO")
                  }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.HOTELNO')" prop="hotelConfirm" class="form-label-field">
                    <span class="colorRed">{{$t("MANUAL.VALIDATEHOTELNOCN")}}</span>
                    <el-input v-model="dataForm.hotelConfirm" @input="clearHotelNoCN()" class="myinput_inner"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.SUPPILENO')" prop="suppilerOrder" class="form-label-field">
                  <el-input v-model="dataForm.suppilerOrder" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <div style="width:80%">
                  <el-form-item :label="$t('MANUAL.CITY')+selectCityName" prop="city.cityName" class="form-label-field">
                    <!-- 目的城市子组件 returnParentValue：给子组件赋值   returnParentValue：子组件返回值（调用方法接收）-->
                    <destination :parentCityCode="dataForm.city.cityCode" :initialValue="dataForm.city.cityName" @returnCityInfo="setDestination" :isHotCity="false"></destination>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.ORDERSTATUS')" prop="orderStatus" class="form-label-field">
                  <el-select v-model="dataForm.orderStatus" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner" @change="orderStatusChange">
                    <el-option v-for="item in ORDERSTATUSOPTION" :key="item.label" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CHECKIN')" prop="checkinDate" class="form-label-field">
                  <el-date-picker class="mytime_inner timeicon_inner" v-model="dataForm.checkinDate" type="date" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" @change="handleChangeDate">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CHECKOUT')" prop="checkOutDate" class="form-label-field">
                  <el-date-picker class="mytime_inner timeicon_inner" v-model="dataForm.checkOutDate" type="date" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" @change="handleChangeDate">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.PAYMENTSTATUS')" prop="paymentStatus" class="form-label-field">
                  <el-select v-model="dataForm.paymentStatus" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner" @change="checkIsOpenOtherGuest">
                    <el-option v-for="item in PAYMENTSTATUSOPTION" :key="item.label" :label="item.label" :value="item.value" :disabled="item.disabled">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.SETTLEMENT')" prop="settlementMethod" class="form-label-field">
                  <el-select v-model="dataForm.settlementMethod" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner" @change="paymeTypeChange">
                    <el-option v-for="item in SETTLEMENTOPTION" :key="item.label" :label="item.label" :value="item.value" :disabled="item.disabled">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.PRICETYPE')" prop="priceType" class="form-label-field">
                  <el-select v-model="dataForm.priceType" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner" @change="priceTypeChange">
                    <el-option v-for="item in PRICETYPEOPTION" :key="item.label" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.RATEACCESSCODE')" class="form-label-field">
                  <el-input v-model="dataForm.rateAccessCode" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.SERVICEFREE')" prop="servicefee" class="form-label-field">
                  <el-input v-model="dataForm.servicefee" class="myinput_inner" @input="clearNoNumServicefee()"></el-input>
                </el-form-item>
              </el-col>
                 <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <el-form-item :label="$t('MANUAL.URGENTFEE')" prop="urgentFee" class="form-label-field">
                    <el-input v-model="dataForm.urgentFee" class="myinput_inner" @input="clearNoNumUrgentfee()"></el-input>
                </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item label="差规:" class="form-label-field">
                  <el-select v-model="dataForm.isOutOfPolicy" class="myselect_inner myicon_inner">
                    <el-option v-for="item in ISOUTOFPOLICYPTION" :key="item.label" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" v-if="showAdvancepayment">
                  <el-form-item :label="advancepaymentMsg" prop="advancePayment" class="form-label-field">
                    <el-input v-model="dataForm.advancePayment" class="myinput_inner"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item :label="$t('MANUAL.REMARK')" class="form-label-field">
                  <el-input type="textarea" :rows="2" v-model="dataForm.remark" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div id="nav4">
          <div style="background-color: #ffffff">
            <el-row :gutter="10" class="row_sty">
              <el-col :span="24" style="padding-left: 0; padding-top: 1rem">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">{{
                    $t("MANUAL.HOTELINFO")
                  }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.HOTELNAME')+selectHotelName" prop="hotel.hotelName" class="form-label-field">
                  <el-input @click="showHotelNamePop" readonly v-model="dataForm.hotel.hotelName" class="myinput_inner"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.STARRATING')" class="form-label-field">
                  <span>{{dataForm.starRating}}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.TELFAX')" class="form-label-field">
                  <span>{{dataForm.telFax}}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="hotelAddress">
                <el-form-item :label="$t('MANUAL.ADDRESS')" class="form-label-field" :title="dataForm.address">
                  <span>{{dataForm.address}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.HOTELTYPE')" prop="hotelType" class="form-label-field">
                  <el-select v-model="dataForm.hotelType" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner">
                    <el-option v-for="item in HOTELTYPEOPTION" :key="item.label" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.BREAKFAST')" prop="breakfast" class="form-label-field">
                  <el-select v-model="dataForm.breakfast" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner">
                    <el-option v-for="item in BREAKFASTOPTION" :key="item.label" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.ROOMTYPE')+selectRoomTypeName" prop="roomType.roomTypeCode" class="form-label-field">
                  <el-select v-model="dataForm.roomType.roomTypeCode" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner">
                    <el-option v-for="(item, index) in roomTypeList" :key="index" :label="$i18n.locale == 'zh' ?item.data.name['zh-CN'] :item.data.name.en" :value="item.data.id" @click="setRoomTypeName(item.data)">
                    </el-option>
                  </el-select>
                  <el-button type="primary" class="syncBtn" @click="hotelAsync()">同步</el-button>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.SMORKING')" class="form-label-field">
                  <el-select v-model="dataForm.smoking" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner">
                    <el-option v-for="item in SMORKINGOPTION" :key="item.label" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="RoomDescription!=''" style="font-size:1.3rem" :gutter="10" class="content_size">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                房型描述:{{RoomDescription}}
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CHANNEL')" prop="channel" class="form-label-field">
                  <el-select v-model="dataForm.channel" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner" @change="channelDropChange">
                    <el-option v-for="item in CHANNELOPTION" :key="item.label" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.MONERARTUNIT')" prop="currencyCode" class="form-label-field">
                    <el-select v-model="dataForm.currencyCode" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" filterable>
                      <el-option v-for="item in this.getcurrencySignData" :key="item" :label="item" :value="item">
                      </el-option>
                    </el-select>	
                </el-form-item>
              </el-col>
               <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" v-if="showTaxes">
                <el-form-item :label="$t('MANUAL.TOTALTAXES')" prop="taxes" class="form-label-field">
                  <el-input v-model="dataForm.taxes" class="myinput_inner" @input="clearNoNumTaxes()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" v-if="showTaxes">
                <el-form-item :label="$t('MANUAL.TOTALFEES')" prop="fees" class="form-label-field">
                  <el-input v-model="dataForm.fees" class="myinput_inner" @input="clearNoNumFees()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <el-form-item :label="$t('MANUAL.LATESTARRIVALTIME')" prop="arrivalTimeInfo.latestArrivalTime" class="form-label-field">
                    <el-time-picker v-model="dataForm.arrivalTimeInfo.latestArrivalTime" format="HH:mm" value-format="HH:mm"></el-time-picker>
                  </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.TOTAL')" prop="prices.totalPrice" class="form-label-field">
                  <el-input v-model="dataForm.prices.totalPrice" @input="clearNoNumTotalPrice()" class="myinput_inner" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <div class="grid-content bg-purple">
                  <el-form-item class="form-label-field" prop="prices.dailyPrices">
                    <el-popover placement="right" width="40%" v-model:visible="dataForm.prices.isvisible" trigger="click">
                      <template #reference>
                        <a @click="setDailyPricesDateData" class="main_link_tab">
                          {{ $t("MANUAL.FILLINTHEDETAILEDDAILYPRICE") }}
                        </a>
                      </template>
                      <div class="pricesDetailsPopover">
                        <div class="title">
                          <p>{{ $t('MANUAL.PRICEDETAILS') }}</p>
                        </div>
                        <!-- 填写夜间价格 -->
                        <table :summary="$t('MANUAL.PRICEDETAILS')">
                          <template v-for="(PricesDateCount, countIndex) in dataForm.prices.dailyPricesDateCount" :key="countIndex">   
                            <tr>
                              <th scope="col" style="width:40px;"> <span>{{ $t('MANUAL.PRICEDETAILSDATE') }}</span></th>
                              <th scope="col" v-for="(item, index) in dataForm.prices.dailyPricesDateData.slice((PricesDateCount - 1) * dataForm.prices.rowSize, PricesDateCount * dataForm.prices.rowSize)" :key="index" style="width:89px;padding-left:2rem;">
                                {{item}}
                              </th>
                            </tr>
                            <tr>
                              <td :colspan="dataForm.prices.dailyPricesDateData.slice((PricesDateCount - 1) * dataForm.prices.rowSize, PricesDateCount * dataForm.prices.rowSize).length+1">
                                <el-divider class="title-divider"></el-divider>
                              </td>
                            </tr>
                            <tr>
                              <td style="width:40px;"> <span>{{ $t('MANUAL.PRICEDETAILSPRICE') }}</span></td>
                              <td v-for="(item, index) in dataForm.prices.dailyPricesDateData.slice((PricesDateCount - 1) * dataForm.prices.rowSize, PricesDateCount * dataForm.prices.rowSize)" :key="index" style="width:89px;padding-left:2rem;">
                                <el-input style="width:125%" v-model="dataForm[item]" @input="clearNoNum(item)" class="myinput_inner" :key="priceFlag"></el-input>
                              </td>
                            </tr>
                            <tr>
                              <td :colspan="dataForm.prices.dailyPricesDateData.slice((PricesDateCount - 1) * dataForm.prices.rowSize, PricesDateCount * dataForm.prices.rowSize).length+1">
                                <el-divider class="title-divider"></el-divider>
                              </td>
                            </tr>
                          </template>
                        </table>
                        <div class="dialog-footer">
                          <el-button type="primary" class="search-btn" @click="PriceFill">一键带入</el-button>
                          <el-button type="primary" class="search-btn" @click="savePriceDetails">{{ $t("MESSAGE.SAVE") }}</el-button>
                          <el-button @click="dataForm.prices.isvisible = false">{{$t("MESSAGE.CONFIRMCANCELTEXT")}}</el-button>
                        </div>
                      </div>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div id="nav5">
          <div style="background-color: #ffffff">
            <el-row :gutter="10" class="row_sty">
              <el-col :span="24" style="padding-left: 0; padding-top: 1rem">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">{{
                    $t("MANUAL.MANAGEMENTINFORMATION")
                  }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col v-for="(item, index) in miList" :key="'mi' + index" :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <!-- 文本类型 -->
                <el-form-item 
                  v-if="item.textTypeCode === 'text'"
                  :label="item.miNameCN" 
                  :rules="[{
                    required: item.needResult == 1,
                    message:'请输入' + item.miNameCN,
                    trigger: ['blur', 'change'],
                  }]" 
                  :prop="item.relationMIKey" 
                  class="form-label-field"
                >
                  <el-input 
                    v-model="dataForm[item.relationMIKey]" 
                    @input="miDropChange($event, item)" 
                    :maxlength="item.textValue.textLength == 0 ? 100 : item.textValue.textLength" 
                    class="myinput_inner"
                  ></el-input>
                  <div style="line-height:10px;">
                    <a 
                      class="miNoteFont" 
                      :title="getMINote(item)" 
                      :class="[getMINoteShow(item)?'miNoteFontT':'miNoteFontF']" 
                      :href="getMINoteLink(item)" 
                      :target="getMINoteShow(item)?'_blank':''"
                    >{{ getMINote(item) }}</a>
                  </div>
                </el-form-item>

                <!-- 下拉类型 -->
                <el-form-item 
                  v-if="item.textTypeCode === 'down'"
                  :label="item.miNameCN" 
                  :rules="[{
                    required: item.needResult == 1,
                    message: '请输入' + item.miNameCN,
                    trigger: ['blur', 'change'],
                  }]" 
                  :prop="item.relationMIKey" 
                  class="form-label-field"
                >
                  <el-select 
                    v-model="dataForm[item.relationMIKey]" 
                    @change="miDropChange($event, item)" 
                    class="myselect_inner myicon_inner"
                  >
                    <el-option 
                      v-for="itemL in item.dropDowns" 
                      :key="itemL.nameCN" 
                      :label="itemL.nameCN" 
                      :value="itemL.downCode"
                    ></el-option>
                  </el-select>
                  <div style="line-height:10px;">
                    <a 
                      class="miNoteFont" 
                      :title="getMINote(item)" 
                      :class="[getMINoteShow(item)?'miNoteFontT':'miNoteFontF']" 
                      :href="getMINoteLink(item)" 
                      :target="getMINoteShow(item)?'_blank':''"
                    >{{ getMINote(item) }}</a>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div id="nav6">
          <div style="background-color: #ffffff">
            <el-row :gutter="10" class="row_sty">
              <el-col :span="24" style="padding-left: 0; padding-top: 1rem">
                <div class="grid-content bg-purple">
                  <span class="grey_small_font">{{
                    $t("MANUAL.POLICYINFO")
                  }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.GUARANTEE1')" prop="guaranteeType" class="form-label-field">
                  <el-select v-model="dataForm.guaranteeType" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner">
                    <el-option v-for="item in GUARANTEE1OPTION" :key="item.label" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item :label="$t('MANUAL.CANCELLATION')" prop="cancellationRules.cancellationPolicy" class="form-label-field">
                  <el-select v-model="dataForm.cancellationRules.cancellationPolicy" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" @change="cancellationPolicyChange" class="myselect_inner myicon_inner">
                    <el-option v-for="item in CANCELLATIONOPTION" :key="item.label" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                <div style="padding-top:3rem;margin-left:-2rem" v-if="dataForm.cancellationRules.cancellationPolicy==2">
                  <el-form-item class="form-label-field" prop="cancellationRules.deadlineDate">
                    <el-date-picker class="mytime_inner timeicon_inner" style="width:50%" v-model="dataForm.cancellationRules.deadlineDate" type="date" :placeholder="$t('MANUAL.SELECTPDEADLINEDATE')">
                    </el-date-picker>
                    <el-select v-model="dataForm.cancellationRules.deadlineTime" :placeholder="$t('MANUAL.SELECTPDEADLINETIME')" class="myselect_inner myicon_inner" style="width:40%">
                      <el-option v-for="item in DEADLINETIMEOPTION" :key="item.label" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div id="submit" class="center_sty">
          <el-button class="s_btn s_btn_small submit-btn" :disabled="!isSubmit" @click="saveManualInfo()">
            {{ $t("MANUAL.SUBMITBACKEND") }}
          </el-button>
          <el-button class="s_btn s_btn_small submit-btn" :disabled="!isSubmit" @click="verifyRepeatOrder()">
            {{ $t("MANUAL.BTNSUBMIT") }}
          </el-button>
        </div>
      </div>
    </el-form>
    <!-- start name dialog -->
    <el-dialog width="90rem" class="dialog-one" v-model="employeeDialogInfo.dialogUserName" :show-close="false">
      <div class="add-guest-div" v-if="guestsDialogInfo.isShowTempGuest">
        <el-button size="default" class="add-guest-btn" @click="employeeDialogInfo.dialogUserName = false;guestsDialogInfo.dialogAddGuest = true; ">
          {{ $t("USERDIALOG.BTNGUEST") }}
        </el-button>
      </div>
      <el-tabs v-model="employeeDialogInfo.userActiveName" type="card">
        <el-tab-pane :label="$t('USERDIALOG.TABNAEM1')" name="first">
          <el-row>
            <el-col :span="6" class="search-input">
              <div>{{ $t("USERDIALOG.SEARCHNAME") }}</div>
              <el-input v-model="employeeDialogInfo.searchName"></el-input>
            </el-col>
            <el-col :span="6" class="search-input">
              <div>{{ $t("USERDIALOG.TABLEEMPLOYEEID") }}</div>
              <el-input v-model="employeeDialogInfo.searchEmployeeID"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" class="search-input">
              <div>{{ $t("USERDIALOG.SEARCHEMAIL") }}</div>
              <el-input v-model="employeeDialogInfo.searchEmail"></el-input>
            </el-col>
            <el-col :span="6" class="search-input">
              <div>{{ $t("USERDIALOG.SEARCHTEL") }}</div>
              <el-input v-model="employeeDialogInfo.searchTel"></el-input>
            </el-col>
            <el-col :span="4" class="search-btn" @click="getTraveler(1)">
              <el-button>{{ $t("USERDIALOG.BTNSEARCH") }}</el-button>
            </el-col>
          </el-row>
          <div>
            <Loading :loading="travelerloading" />
            <el-table :data="employeeDialogInfo.employeeData">
              <el-table-column prop="travelerName" :label="$t('USERDIALOG.TABLENAME')" width="150"></el-table-column>
              <el-table-column prop="staffNum" :label="$t('USERDIALOG.TABLEEMPLOYEEID')" width="150"></el-table-column>
              <el-table-column prop="departmentName" :label="$t('USERDIALOG.DEPARTMENT')"></el-table-column>
              <el-table-column prop="mobile" :label="$t('USERDIALOG.TABLETEL')"></el-table-column>
              <el-table-column prop="email" :label="$t('USERDIALOG.SEARCHEMAIL')"></el-table-column>
              <el-table-column width="120" :label="$t('USERDIALOG.OPERATION')">
                <template #default="scope">
                  <div class="select-btn" @click="selectTraveler(scope.row)">
                    {{ $t("USERDIALOG.SELECT") }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-row style="float: right; margin: 2%">
            <el-pagination background layout="prev, pager, next" :total="employeeDialogInfo.pagination.total" :page-size="employeeDialogInfo.pagination.pageSize" :current-page="employeeDialogInfo.pagination.currentPage" @current-change="pageChange_employeeDialog">
            </el-pagination>
          </el-row>
        </el-tab-pane>

        <el-tab-pane :label="$t('USERDIALOG.GUEST')" name="second" v-if="guestsDialogInfo.isShowTempGuest">
          <el-row>
            <el-col :span="6" class="search-input">
              <div>{{ $t("USERDIALOG.SEARCHNAME") }}</div>
              <el-input v-model="guestsDialogInfo.searchName"></el-input>
            </el-col>
            <el-col :span="6" class="search-input">
              <div>{{ $t("USERDIALOG.SEARCHTEL") }}</div>
              <el-input v-model="guestsDialogInfo.searchTel"></el-input>
            </el-col>
            <el-col :span="4" class="search-btn" @click="getTemporaryGuestList(1)">
              <el-button>{{ $t("USERDIALOG.BTNSEARCH") }}</el-button>
            </el-col>
          </el-row>
          <div>
            <Loading :loading="tempUserloading" />
            <el-table :data="guestsDialogInfo.guestsData">
              <el-table-column prop="psgName" :label="$t('USERDIALOG.TABLENAME')" width="150"></el-table-column>
              <el-table-column prop="mobile" :label="$t('USERDIALOG.TABLETEL')"></el-table-column>

              <el-table-column prop="email" :label="$t('USERDIALOG.EMAIL')"></el-table-column>
              <el-table-column width="150" :label="$t('USERDIALOG.OPERATION')">
                <template #default="scope">
                  <div class="select-btn" @click="selectGuest(scope.row)">
                    {{ $t("USERDIALOG.SELECT") }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-row style="float: right; margin: 2%">
            <el-pagination background layout="prev, pager, next" :total="guestsDialogInfo.pagination.total" :page-size="guestsDialogInfo.pagination.pageSize" :current-page="guestsDialogInfo.pagination.currentPage" @current-change="pageChange_guestsDialog">
            </el-pagination>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- end name dialog -->

    <!-- start add guest dialog -->
    <el-dialog width="40rem" class="dialog-two" :title="$t('USERDIALOG.BTNGUEST')" v-model="guestsDialogInfo.dialogAddGuest" :show-close="false" append-to-body>
      <el-divider class="title-divider"></el-divider>
      <el-form :model="addGuestInfo" label-position="right" style="text-align: center" :rules="guestRules" ref="addGuestInfo" :inline="true">
        <el-row class="dialog-form-row">
          <el-col :span="24">
            <el-form-item :label="$t('USERDIALOG.NAME')" prop="guestName">
              <el-input v-model="addGuestInfo.guestName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog-form-row">
          <el-col :span="24">
            <el-form-item :label="$t('USERDIALOG.TEL')" prop="guestMobile">
              <el-input v-model="addGuestInfo.guestMobile" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog-form-row">
          <el-col :span="24">
            <el-form-item :label="$t('USERDIALOG.EMAIL')" prop="guestEmail">
              <el-input v-model="addGuestInfo.guestEmail" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" class="search-btn" @click="addGuest">{{ $t("MESSAGE.CONFIRMBUTTONTEXT") }}</el-button>
        <el-button @click="guestsDialogInfo.dialogAddGuest = false">{{$t("MESSAGE.CONFIRMCANCELTEXT")}}</el-button>
      </div>
      </template>
    </el-dialog>
    <!-- end add guest dialog -->

    <!-- start Approved Trips list dialog -->
    <el-dialog width="90rem" class="dialog-one" v-model="approvedTripsDialogInfo.dialogApprovedTrips" :show-close="false">
      <el-tabs v-model="approvedTripsDialogInfo.approvedTripsActiveName" type="card">
        <el-tab-pane :label="$t('MANUAL.APPROVEDTRIPSLIST')" name="first">
          <el-row>
            <el-col :span="4" class="search-input">
              <el-select v-model="approvedTripsDialogInfo.approvedTripsType" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner" style="width:100%;padding-top:2rem">
                <el-option v-for="item in APPROVEDTRIPSTYPEOPTION" :key="item.label" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4" style="padding-top: 1rem;padding-left: 0.5rem;">
              <el-input v-model="approvedTripsDialogInfo.approvedTripsNo" style="padding-top:1rem"></el-input>
            </el-col>
            <el-col :span="4" class="search-input">
              <div>{{ $t("MANUAL.APPROVEDTRIPSREASON") }}</div>
              <el-input v-model="approvedTripsDialogInfo.approvedTripsReason"></el-input>
            </el-col>
            <el-col :span="3" class="search-btn" @click="getTravelApplyOrderList(1)">
              <el-button>{{ $t("USERDIALOG.BTNSEARCH") }}</el-button>
            </el-col>
          </el-row>
          <div>
            <Loading :loading="approvedTripsloading" />
            <el-table :data="approvedTripsDialogInfo.approvedTripsData">
              <el-table-column prop="triporderno" :label="$t('MANUAL.SYSTEMAPPROVEDTRIPSNO')" width="120"></el-table-column>
              <el-table-column prop="customerOrderNo" :label="$t('MANUAL.CUSTOMERAPPROVEDTRIPSNO')" width="120"></el-table-column>
              <el-table-column prop="travelersNames" :label="$t('MANUAL.APPROVEDTRIPSERPERSONNEL')"></el-table-column>
              <el-table-column prop="locationNames" :label="$t('MANUAL.APPROVEDTRIPSLOCATION')"></el-table-column>
              <el-table-column prop="tripPurpose" :label="$t('MANUAL.APPROVEDTRIPSREASON')"></el-table-column>
              <el-table-column prop="approvedTripDate" :label="$t('MANUAL.APPROVEDTRIPSDate')" width="185"></el-table-column>
              <el-table-column width="100" :label="$t('USERDIALOG.OPERATION')">
                <template #default="scope">
                  <div class="select-btn" @click="selectApprovedTrip(scope.row)">
                    {{ $t("USERDIALOG.SELECT") }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-row style="float: right; margin: 2%">
            <el-pagination background layout="prev, pager, next" :total="approvedTripsDialogInfo.pagination.total" :page-size="approvedTripsDialogInfo.pagination.pageSize" :current-page="approvedTripsDialogInfo.pagination.currentPage" @current-change="pageChange_travelApplyOrderDialog">
            </el-pagination>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- end Approved Trips list dialog -->

    <!-- start 酒店名称 dialog -->
    <el-dialog width="110rem" class="dialog-one" v-model="hotelDialogInfo.dialogHotel" :show-close="false">
      <el-tabs v-model="hotelDialogInfo.hotelActiveName" type="card">
        <el-tab-pane :label="$t('MANUAL.HOTELIST')" name="first">
          <el-row>
            <el-col :span="6" class="search-input">
              <div>{{ $t("MANUAL.SEACHHOTELNAME") }}</div>
              <el-input v-model="hotelDialogInfo.searchHotelName"></el-input>
            </el-col>
            <el-col :span="6" class="search-input">
              <div>{{ $t("MANUAL.SEACHSTARRATING") }}</div>
              <el-select v-model="hotelDialogInfo.searchStarRating" :placeholder="$t('MANUAL.SELECTPLACEHOLDER')" class="myselect_inner myicon_inner" clearable>
                <el-option v-for="item in STARTRATINGOPTION" :key="item.label" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" class="search-input">
              <div>{{ $t("MANUAL.CONTACTTEL") }}</div>
              <el-input v-model="hotelDialogInfo.searchContactTel"></el-input>
            </el-col>
            <el-col :span="6" class="search-btn" @click="getHotelList(1,false)">
              <el-button style="margin-left:4.5rem">{{ $t("MANUALORDERHOTEL.SEARCHBUTTON") }}</el-button>
            </el-col>
          </el-row>
          <div>
            <Loading :loading="hotelloading" />
            <el-table :data="hotelDialogInfo.hotelData">
              <el-table-column prop='id' :label="$t('MANUAL.FXID')" align="center"></el-table-column>
              <el-table-column prop='name.zh-CN' :label="$t('MANUAL.HOTELNAMECN')" width="170" align="center"></el-table-column>
              <el-table-column prop="name.en" :label="$t('MANUAL.HOTELNAMEEN')" width="170" align="center"></el-table-column>
              <el-table-column prop="starRating" :label="$t('MANUAL.SEACHSTARRATING')" width="50" align="center"></el-table-column>
              <!-- <el-table-column prop="countryName" :label="$t('MANUALORDERHOTEL.COUNTRYNAME')" width="100" align="center"></el-table-column> -->
              <el-table-column prop="provinceName" :label="$t('MANUALORDERHOTEL.PROVINCENAME')" width="100" align="center"></el-table-column>
              <el-table-column prop="cityName" :label="$t('MANUALORDERHOTEL.CITYNAME')" width="100" align="center"></el-table-column>
              <el-table-column prop="contactNumber" :label="$t('MANUAL.CONTACTTEL')" width="135" align="center"></el-table-column>
              <el-table-column prop="address.zh-CN" :label="$t('MANUAL.HOTELADDRESS')" align="center"></el-table-column>
             <el-table-column prop="isActive" label="是否在售" align="center">
                <template #default="{ row }">
                  <el-icon v-if="row.isActive" color="green"><Check /></el-icon>
                  <el-icon v-else color="red"><Close /></el-icon>
                </template>
              </el-table-column>
              <el-table-column width="100" :label="$t('USERDIALOG.OPERATION')">
                <template #default="scope">
                  <div class="select-btn" @click="selectHotel(scope.row)">
                    {{ $t("USERDIALOG.SELECT") }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-row style="float: right; margin: 2%">
            <el-pagination background layout="prev, pager, next" :total="hotelDialogInfo.pagination.total" :page-size="hotelDialogInfo.pagination.pageSize" :current-page="hotelDialogInfo.pagination.currentPage" @current-change="pageChange_hotelDialog">
            </el-pagination>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- end 酒店名称 dialog -->

    <!-- start 渠道 dialog -->
    <el-dialog width="40rem" class="dialog-two" :title="$t('MANUAL.CHANNELDIALOGTITLE')" v-model="channelDialogInfo.dialogChannel" :show-close="false" append-to-body>
      <el-divider class="title-divider"></el-divider>
      <el-form :model="channelDialogInfo" label-position="right" style="text-align: center" :inline="false">
        <el-row class="dialog-form-row">
          <el-col :span="24">
            <el-form-item class="form-label-field">
              <el-input v-model="channelDialogInfo.channel" type="textarea" rows="2" resize="none" autocomplete="off" style="width:70%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" class="search-btn" @click="saveOtherChannel()">{{ $t("MESSAGE.CONFIRMBUTTONTEXT") }}</el-button>
          <el-button @click="channelDialogInfo.dialogChannel = false">{{$t("MESSAGE.CONFIRMCANCELTEXT")}}</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- end 渠道 dialog -->

       <!-- 判断是否有重复订单弹框 -->

    <el-dialog width="40rem" class="dialog-two" 
    v-model="verifyRepeatOrderFlag"
    :show-close="false" append-to-body>
    <el-divider class="title-divider"></el-divider>
     <el-form :model="channelDialogInfo" label-position="right" style="text-align: center" :inline="false">
        <el-row class="dialog-form-row">
          <el-col :span="24">
            <el-form-item class="form-label-field">
           {{ $t("BOOKING.VERIFYREPEATORDERTITLE") }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" class="search-btn" @click="continueRepeatOrderConfirm()">{{ $t("CONFIRMATION.PROCEED")  }}</el-button>
          <el-button @click="CancelRepeatOrderConfirm()">{{$t("CONFIRMATION.CANCLEBTN")}}</el-button>
        </div>
      </template>
    </el-dialog>
    <!--start 待补单列表 dialog -->
    <ManualOrderPending @selectManualOrder="selectManualOrder" :isOpen="manualOrderInfo.manualDialog" @child-dialog-closed="handleDialogClosed" @openConfirmFlag="openConfirmFlag"></ManualOrderPending>
    <!-- end 待补单列表 dialog -->
    <!-- 子组件确认框  confirmMsg 提示内容-->
    <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" :icon="confirmIcon" :buttonMsg="buttonMsg" @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
    <ClientList :customerDialogVisible = "clientListFlag" @setCustomerFlag = "setCustomerFlag" @customerInfo = "selectClient"></ClientList>
    <CardTypeDialog 
      :centerDialogVisible="dialogValue" 
      :cardType="selectedCardType" 
      :isTemporary ="dataForm.traveler.isTemporary"
      :lKPKID ="dataForm.traveler.lKPKID"
      :loginid ="dataForm.traveler.userId"
      :userid = "dataForm.traveler.RefId"
      @cancelCardTypeDialog="cancelCardTypeDialog" 
      @cardTypeSubmit="handleCardTypeSubmit">
    </CardTypeDialog>
    <CardTypeDialog 
      :centerDialogVisible="dialogOtherValue" 
      :cardType="selectedOtherCardType" 
      :isTemporary ="dataForm.bookingFormOther.isTemporary"
      :lKPKID ="dataForm.bookingFormOther.lKPKID"
      :loginid ="dataForm.bookingFormOther.travelerCode"
      :userid = "dataForm.bookingFormOther.refId"
      @cancelCardTypeDialog="cancelCardTypeOtherDialog" 
      @cardTypeSubmit="handleCardTypeOtherSubmit">
    </CardTypeDialog>
  </div>
</template>

<script>
import { travelerLookup, getCustomerMI, getTemporaryGuestList, searchTravelApplyOrder, pointSearch,getServiceCharge,getuatp,getCostCenter,getCustomerLookup} from "../../api/platformData.js";
import Destination from "../../components/Destination.vue";
import { formatDateTime, hideElement, isEnglishAndOther, isChinese, codeIsCode,getServerTimeAxios,_debounce,isCityGAT,debounce,getCityInfoByCode} from "../../utils/utils.js";
import { createBooking, verifyRepeatOrder,getConsul,saveManual,getHotelOrderInfo} from "../../api/bookingData.js";
import { roomTypeList, getHotelLookup,getcountryList,getHotelList } from "../../api/shoppingData.js";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import Loading from "@/components/Loading.vue";
import { currencySign } from "@/config/currency";
import ClientList from "@/components/ClientList.vue";
import ManualOrderPending from "@/views/manualOrder/ManualOrderPending.vue";
import CardTypeDialog from "@/components/CardTypeDialog.vue";
import { Search,Check, Close } from '@element-plus/icons-vue'
export default {
  name: "manualOrder",
  components: {
    Destination,
    ConfirmBoxs: ConfirmBoxs,
    Loading,
    ClientList,
    ManualOrderPending,
    CardTypeDialog,
    Search,
    Check,
    Close
  },
  data() {
    //持卡人姓名正则 英文
    var validatePass = (rule, value, callback) => {
      console.log(this.$i18n.locale, localStorage.getItem("language"));
      if (this.$i18n.locale == "en") {
        //英文 必须是全英加空格
        if (!isEnglishAndOther(value)) {
          callback(new Error(this.$t("BOOKING.GUESTNAMERULE")));
        } else {
          callback();
        }
      } else {
        //中文
        if (isEnglishAndOther(value) || isChinese(value)) {
          callback();
        } else {
          callback(new Error(this.$t("BOOKING.GUESTNAMERULE")));
        }
      }
    };
    return {
      clientListFlag: false,
      // fullFlag:false,
      destinationType:"",
      customerCodeChoosen: "",
      chargeType: "3",
      agreePriceType: "",
      paymeType: "2",
      showAdvancepayment : false,
      advancepaymentMsg: "",
      r2AppendChargeFeeType: 0,
      guestNameRule: validatePass,
      miLoading: false,
      submitLoading: false, //提交等待
      customerloading: false,
      travelerloading: false,
      tempUserloading: false,
      approvedTripsloading: false,
      hotelloading: false,
      confirmIcon: "",
      confirmMsg: "", //提示消息内容
      confirmFlag: false, //提示框是否弹出
      buttonMsg: false,
      showTaxes: true,//展示总税费
      provinceCode:['810000','820000','710000'],//港澳台
      dataForm: {
        customer: {
          customerId: "",
          customerName: "",
          ordApprovalType: "",
          strongControl: "",
        },
        contact: {
          type: "2",
          contactName: "",
          contactMobile: "",
          contactEmail: "",
          userId: "",
          userLevel: "",
          departmentCode: "",
          departmentName: "",
          languageValue: "",
        },
        traveler: {
          travelerName: "",
          mobile: "",
          email: "",
          userId: "",
          userLevel: "",
          departmentCode: "",
          departmentName: "",
          isEmployee: true,
          linkerName: "",
          linkerMobile: "",
          linkerEmail: "",
          birthday: "",
          idCardNumber: "",
          passportNumber: "",
          visaCountry: "",
          sex: "",
          cardType:"NI",//证件类型
          cardTypeNumber:"",
          cardTypeSelectDisabled:false,
          cardTypeButtonDisabled:false,
          showIdNumber:false,
          lKPKID :0,
          isTemporary :false,
        },
        approvedTrips: {
          systemTripNo: "",
          customerTripNo: "",
          location: ""
        },
        hotelConfirm: "",
        suppilerOrder: "",
        city: {
          cityCode: "",
          cityName: "",
        },
        orderStatus: "BOOKED",
        checkinDate: "",
        checkOutDate: "",
        paymentStatus: "",
        settlementMethod: "1",
        priceType: "",
        rateAccessCode: "",
        servicefee: "",
        urgentFee:"",
        advancePayment: "",
        remark: "",
        hotel: {
          hotelCode: "",
          hotelName: "",
          hotelNameEN: "",

        },
        fxHotelCityInfo: {
          cityCode: 0,
          cityName: "",
          provinceName: "",
          countryName: "",
        },
        starRating: "",
        telFax: "",
        address: "",
        breakfast: "",
        hotelType: "",
        roomType: {
          roomTypeCode: "",
          roomTypeName: "",
        },
        smoking: "",
        channel: "",
        currencyCode: this.destinationType === 'D'? "CNY" : '',
        prices: {
          dailyPricesDateData: [],
          dailyPricesDateCount: 1,
          rowSize: 7,
          dailyPrices: [],
          totalPrice: "",
          isvisible: false,
        },
        taxes: "",
        fees: "",
        guaranteeType: "",
        cancellationRules: {
          cancellationPolicy: "",
          deadlineDate: "",
          deadlineTime: ""
        },
        arrivalTimeInfo:{
          latestArrivalTime:"16:00",
        },
        uatpCardNo:"",//uatp卡号
        costCenterid:0,//成本中心id
        uatpCardValidDate:"",//uatp卡有效期
        supplierAndModel:"",//uatp供应商及模式
        isopenCTA:false,//是否打开CTA
        bookingFormOther: {
          name:"",
          mobile: "",
          email:"",
          travelerCode: "",
          refId: "",
          userLevel: "",
          departmentCode: "",
          departmentName: "",
          isEmployee: "",
          linkerName: "",
          linkerMobile: "",
          linkerEmail: "",
          birthday: "",
          idCardNumber: "",
          passportNumber: "",
          visaCountry: "",
          sex: "",
          cardType:"NI",//证件类型
          cardTypeNumber:"",
          cardTypeSelectDisabled:false,
          cardTypeButtonDisabled:false,
          showIdNumber:false,
          lKPKID :0,
          isTemporary :false,
        }, //创建订单参数-其他人
        isShowOtherGuest: false,
        BookingCodeManualOrder:"",//生成待补单列表时是否生成订单号
        clientOrderNo:"",//第三方订单号
        showLinker:false,
        isOutOfPolicy: false, //是否超出政策
      },
      ORDERSTATUSOPTION: [
        { label: "预订成功", value: "BOOKED" },
        { label: "预订失败", value: "BOOKING_FAILED" }
      ],
      PAYMENTSTATUSOPTION: [
        { label: "现付", value: "0" },
        { label: "现付(已担保)", value: "1" },
        // { label: "预付(已支付)", value: "2" },
        // { label: "预付(未支付)", value: "3" },
        { label: "公付", value: "4" },
      ],
      SETTLEMENTOPTION: [
        { label: "现付", value: "1" },
        // { label: "预付", value: "2" },
        { label: "公付", value: "3" },
      ],
      PRICETYPEOPTION: [
        { label: "CWT协议价格", value: "2" },
        { label: "公司协议价格", value: "3" },
        { label: "非协议价格", value: "1" },
      ],
      HOTELTYPEOPTION: [
        { label: "CWT协议酒店", value: "1" },
        { label: "公司协议酒店", value: "2" },
        { label: "非协议酒店", value: "3" },
      ],
      BREAKFASTOPTION: [
        { label: "含早", value: "99" },
        { label: "不含早", value: "0" },
        { label: "未知", value: "100" },
      ],
      SMORKINGOPTION: [
        { label: "无烟", value: "N" },
        { label: "吸烟", value: "Y" },
        { label: "未知", value: "U" },
      ],
      CHANNELOPTION: [
        { label: "sabre", value: "sabre" },
        { label: "atour", value: "atour" },
        { label: "酒店官网", value: "酒店官网" },
        { label: "酒店电话中心", value: "酒店电话中心" },
        { label: "直接拨打酒店", value: "直接拨打酒店" },
        { label: "atour", value: "atour" },
        { label: "wehotel", value: "wehotel" },
        { label: "其他", value: "-1" },
      ],
      GUARANTEE1OPTION: [
        { label: "全部担保", value: "1" },
        { label: "首晚担保", value: "2" },
        { label: "无需担保", value: "3" },
      ],
      CANCELLATIONOPTION: [
        { label: "不可取消", value: "0" },
        { label: "限时取消", value: "2" },
        { label: "随时取消", value: "1" },
      ],
      DEADLINETIMEOPTION:Array.from({ length: 24 }, (_, index) => ({
        label: `${index.toString().padStart(2, '0')}:00`,
        value: index.toString()
      })),
      APPROVEDTRIPSTYPEOPTION: [
        { label: "系统出差单号", value: "1" },
        { label: "客户出差单号", value: "2" },
      ],
      STARTRATINGOPTION: [
        { label: "2星及以下/经济", value: "2" },
        { label: "3星/舒适", value: "3" },
        { label: "4星/高档", value: "4" },
        { label: "5星及以上/豪华", value: "5" },
      ],
      ISOUTOFPOLICYPTION: [
        { label: "符合政策", value: false },
        { label: "违背政策", value: true },
      ],
      miList: [],
      roomTypeList: [],
      employeeDialogInfo: {
        dialogUserName: false,
        userActiveName: "first",
        searchName: "", //name search
        searchEmployeeID: "", //tel search
        searchEmail: "", //name search
        searchTel: "", //tel search
        employeeData: [],
        pagination: {
          total: 0, //总数
          pageSize: 5,
          currentPage: 1
        }, //分页信息
      },

      guestsDialogInfo: {
        dialogAddGuest: false,
        isShowTempGuest: false,
        searchName: "", //name search
        searchTel: "", //tel search
        guestsData: [],
        pagination: {
          total: 0, //总数
          pageSize: 5,
          currentPage: 1
        }, //分页信息
      },

      clientDialogInfo: {
        selectedCustomerCode: "",
      },

      approvedTripsDialogInfo: {
        dialogApprovedTrips: false,
        approvedTripsActiveName: "first",
        approvedTripsType: "",
        approvedTripsNo: "",
        approvedTripsReason: "",
        approvedTripsData: [],
        pagination: {
          total: 0, //总数
          pageSize: 5,
          currentPage: 1
        }, //分页信息
      },

      hotelDialogInfo: {
        dialogHotel: false,
        hotelActiveName: "first",
        searchHotelName: "",
        searchStarRating: "",
        searchContactTel: "",
        hotelCode:"",
        hotelData: [],
        pagination: {
          total: 0, //总数
          pageSize: 5,
          currentPage: 1
        }, //分页信息
      },
      channelDialogInfo: {
        dialogChannel: false,
        channel: "",
        channelValue: "",
      },

      addGuestInfo: {
        guestName: "",
        guestMobile: "",
        guestEmail: "",
      },
      orderIdTo: "", //订单ID
      verifyRepeatOrderFlag:false,//验证是否有重复订单
      isSubmit:true,//判断提交按钮是否可以点击
      // poscod: "",
      validateHotelNo: false,
      languageValue: "",
      priceFlag:0,
      isCostCenterOpen:false,//是否打开成本中心(是否必填)
      isCostCenterShow:false,//是否展示成本中心
      isCostCenterEdit:false,//是否可以修改成本中心
      isValidUATP:false,//是否验证UATP卡
      isValidExpiredUATP:false,//验证UATP卡是否过期
      costCenterType:"",//成本中心type
      CostCenterList:[],//成本中心列表
      costCenteroptions:[],//成本中心展示列表
      costCenterrangeNumber:50,//成本中心最大展示数量
      isRepeat:false,//是否重单
      showButton: false,
      isOtherGuest:false,
      manualOrderInfo:{
        manualDialog: false,
        manualCode:"",
      },
      changeGuestCheckBox:true,
      selectCityName:"",
      selectHotelName:"",
      selectRoomTypeName:"",
      searchParm:this.$route?.query?.param || "",
      copyOrderListInfo:{},
      orderStatus_Failed:true,
      ManualOrderCreate:"",//创建人
      ManualOrderCreateUserId:"",//创建员工号
      RoomDescription:"",
      manualOrderListCostCenterid:"",
      cardTypeOption:[],
      dialogValue:false,
      dialogOtherValue:false,
      selectedCardType:"",
      selectedOtherCardType:"",
    };
  },
  computed: {
    guestRules() {
      return {
        guestName: [{ required: true, message: this.$t("USERDIALOG.GUESTNAME"), trigger: "blur", }, {
          validator: this.guestNameRule,
          trigger: 'blur',
        },],
        guestMobile: [
          { required: true, message: this.$t("USERDIALOG.GUESTMOBILE"), trigger: "blur", },
          { pattern: /^1[3456789]\d{9}$/, message: this.$t("MANUAL.VALIDATEPHONEFORMAT"), trigger: ["blur", "change"], }
        ],
        guestEmail: [
          { required: true, message: this.$t("USERDIALOG.GUESTEMAIL"), trigger: "blur", },
          { type: "email", message: this.$t("USERDIALOG.GUESTEMAIL2"), trigger: ["blur", "change"], },
        ],
      }
    },
    bookingRules() {
      return {
        "customer.customerName": [{ required: true, message: this.$t("MANUAL.VALIDATECUSTOMERNAME"), trigger: ["blur", "change"], }],
        "contact.contactName": [{ required: true, message: this.$t("MANUAL.VALIDATECONTACTNAME"), trigger: ["blur", "change"], }],
        "contact.contactMobile": [
          { required: true, message: this.$t("MANUAL.VALIDATECONTACTMOBILE"), trigger: ["blur", "change"], },
          { pattern: /^1[3456789]\d{9}$/, message: this.$t("MANUAL.VALIDATEPHONEFORMAT"), trigger: ["blur", "change"], }
        ],
        "contact.contactEmail": [
          { required: true, message: this.$t("MANUAL.VALIDATECONTACTEMAIL"), trigger: ["blur", "change"], },
          { type: "email", message: this.$t("USERDIALOG.GUESTEMAIL2"), trigger: ["blur", "change"], }
        ],
        "traveler.travelerName": [{ required: true, message: this.$t("USERDIALOG.GUESTNAME"), trigger: "blur", }, {
          validator: this.guestNameRule,
          trigger: ["blur", "change"],
        },],
        "traveler.mobile": [
          { required: true, message: this.$t("MANUAL.VALIDATEMOBILE"), trigger: ["blur", "change"], },
          { pattern: /^1[3456789]\d{9}$/, message: this.$t("MANUAL.VALIDATEPHONEFORMAT"), trigger: ["blur", "change"], }
        ],
        "traveler.email": [{ required: true, message: this.$t("MANUAL.VALIDATEEMAIL"), trigger: ["blur", "change"], },
        { type: "email", message: this.$t("USERDIALOG.GUESTEMAIL2"), trigger: ["blur", "change"], }
        ],
        "city.cityName": [{ required: true, message: this.$t("MANUAL.VALIDATECITYNAME"), trigger: ["blur"], }],
        "orderStatus": [{ required: true, message: this.$t("MANUAL.VALIDATEORDERSTATUS"), trigger: ["blur", "change"], }],
        "checkinDate": [{ required: true, validator: this.validateCheckInDate, trigger: ["blur", "change"], }],
        "checkOutDate": [{ required: true, validator: this.validateCheckOutDate, trigger: ["blur", "change"], }],
        "paymentStatus": [{ required: true, message: this.$t("MANUAL.VALIDATEPAYMENTSTATUS"), trigger: ["blur", "change"], }],
        "settlementMethod": [{ required: true, message: this.$t("MANUAL.VALIDATESETTLEMENTMETHOD"), trigger: ["blur", "change"], }],
        "priceType": [{ required: true, message: this.$t("MANUAL.VALIDATEPRICETYPE"), trigger: ["blur", "change"], }],
        "hotelType": [{ required: true, message: this.$t("MANUAL.VALIDATEHOTELTYPE"), trigger: ["blur", "change"], }],
        "servicefee": [{ required: this.orderStatus_Failed, message: this.$t("MANUAL.VALIDATESERVICEFEE"), trigger: ["blur", "change"], }],
        "urgentFee": [{ required: this.orderStatus_Failed, message: this.$t("MANUAL.VALIDATEURGENTFEE"), trigger: ["blur", "change"], }],
        "hotel.hotelName": [{ required: true, message: this.$t("MANUAL.VALIDATEHOTELNAME"), trigger: ["blur", "change"], }],
        "roomType.roomTypeCode": [{ required: true, message: this.$t("MANUAL.VALIDATEROOMTYPENAME"), trigger: ["blur", "change"], }],
        "breakfast": [{ required: true, message: this.$t("MANUAL.VALIDATEBREAKFAST"), trigger: ["blur", "change"], }],
        "channel": [{ required: true, validator: this.validateChannel, trigger: ["blur", "change"], }],
        "currencyCode": [{ required: true, message: this.$t("MANUAL.VALIDATECURRENCYCODE"), trigger: ["blur", "change"], }],
        "prices.totalPrice": [{ required: this.orderStatus_Failed, message: this.$t("MANUAL.VALIDATETOTALPRICE"), trigger: ["blur", "change"], }],
        "prices.dailyPrices": [{ validator: this.validateDailyPrices, trigger: ["blur", "change", "click"], }],
        "guaranteeType": [{ required: true, message: this.$t("MANUAL.VALIDATEGUARANTEETYPE"), trigger: ["blur", "change"], }],
        "cancellationRules.cancellationPolicy": [{ required: true, message: this.$t("MANUAL.VALIDATECANCELLATIONPOLICY"), trigger: ["blur", "change"], }],
        "cancellationRules.deadlineDate": [{ required: true, validator: this.validateDeadlineTime, trigger: ["blur", "change"], }],
        "advancePayment": [{ required: this.orderStatus_Failed, message: this.$t("MANUAL.VALIDATEADVANCEPAYMENT"), trigger: ["blur", "change"], }],
        "arrivalTimeInfo.latestArrivalTime": [{ required: true, message: this.$t("MANUAL.VALIDATELATESTARRIVALTIME"), trigger: ["blur", "change"], }],
        "bookingFormOther.name": [{ required: true, message: this.$t("MANUAL.VALIDATETRAVELERNAME"), trigger: ["blur", "change"], }],
        "bookingFormOther.mobile": [
          { required: true, message: this.$t("MANUAL.VALIDATEMOBILE"), trigger: ["blur", "change"], },
          { pattern: /^1[3456789]\d{9}$/, message: this.$t("MANUAL.VALIDATEPHONEFORMAT"), trigger: ["blur", "change"], }
        ],
        "bookingFormOther.email": [{ required: true, message: this.$t("MANUAL.VALIDATEEMAIL"), trigger: ["blur", "change"], },
        { type: "email", message: this.$t("USERDIALOG.GUESTEMAIL2"), trigger: ["blur", "change"], }
        ],
        "suppilerOrder": [{ required: this.getDataFormChannel, message: "请输入供应商单号", trigger: ["blur", "change"], },
          { pattern:this.getDataFormChannel && /^[A-Za-z0-9]{6}$/, message: '仅支持录入六位的数字和字母', trigger: ["blur", "change"], }
        ],
        "hotelConfirm": [{ required: this.validateHotelNo || this.getDataFormChannel || this.getDataFormBookingChannel, message: this.$t("MANUAL.VALIDATEHOTELNO"), trigger: ["blur", "change"], },
          { pattern: (this.validateHotelNo || this.getDataFormChannel || this.getDataFormBookingChannel) && /^[A-Za-z0-9-]*$/, message: '仅支持录入数字、字母和- ', trigger: ["blur", "change"],},
          { min: 1, max: 30, message: '长度不能超过30位', trigger: ["blur", "change"] }],
        }
    },
    getcurrencySignData() {
      var keys = Object.keys(currencySign);
      return keys;
    },
    getMINote(){
      return (item) => {
        let note="";
        if(item!=null && item!=undefined && item!=""){
          if(this.$i18n.locale == "en"){
            if(item.noteEN!=undefined && item.noteEN!=null && item.noteEN!=""){
              note=item.noteEN
              if(note.length>60){
                note=note.substring(0,60)+"..."
              }
            }else{
              return "";
            }
          }else{
            if(item.noteCN!=undefined && item.noteCN!=null && item.noteCN!=""){
              note=item.noteCN;
              if(note.length>35){
                note=note.substring(0,35)+"..."
              }
            }else{
              return "";
            }
          }
        }else{
          return "";
        }
        return note;
      };
    },
    getMINoteLink(){
      return (item) => {
        if(item!=null && item!=undefined && item!=""){
          if(this.$i18n.locale == "en"){
            if(item.noteENLink!=undefined && item.noteENLink!=null && item.noteENLink!=""){
              return item.noteENLink;
            }else{
              return "javascript:void(0)";
            }
          }
          else{
            if(item.noteCNLink!=undefined && item.noteCNLink!=null && item.noteCNLink!=""){
              return item.noteCNLink;
            }else{
              return "javascript:void(0)";
            }
          }
        }else{
          return "";
        }
      }
    },
    getMINoteShow(){
      return (item) => {
        if(item!=null && item!=undefined && item!=""){
          if(this.$i18n.locale == "en"){
            if(item.noteENLink!=undefined && item.noteENLink!=null && item.noteENLink!=""){
              return true;
            }else{
              return false;
            }
          }else{
            if(item.noteCNLink!=undefined && item.noteCNLink!=null && item.noteCNLink!=""){
              return true;
            }else{
              return false;
            }
          }
        }else{
          return false;
        }
      };
    },
    //获取成本中心下来赋值
    getCostCenterValue()
    {
      return (item) => {
        if(item!=null && item!=undefined && item!=""){
          let value=item.costName;
          if(item.uatpno!=null && item.uatpno!=undefined && item.uatpno!="" && this.$objBaseInfo.sourceType == 'CRM'){
            let uatpno=item.uatpno;
            if(uatpno.length>=10){
              let star="";
              let starLength=uatpno.length-9;
              for (let i=0; i<starLength; i++) {
                star+="*";
              }
              uatpno=uatpno.replace(/(?<=\d{4})\d+(?=\d{5})/,star);
            }else if(uatpno.length>=6){
              let star="";
              let starLength=uatpno.length-5;
              for (let i=0; i<starLength; i++) {
                star+="*";
              }
              uatpno=star+uatpno.substr(uatpno.length-5);
            }else{
              let star="";
              let starLength=uatpno.length-2;
              for (let i=0; i<starLength; i++) {
                star+="*";
              }
              uatpno=star+uatpno.substr(uatpno.length-2);
            }
            value+="-"+uatpno;
          }
          return value;
        }
        else
        {
          return "";
        }
      }
    },
    //获取渠道选项
    getDataFormChannel(){
      if(this.dataForm.orderStatus == 'BOOKING_FAILED'){
        return false;
      }if(this.dataForm.channel == "-1"){
        if(this.channelDialogInfo.channelValue==undefined || this.channelDialogInfo.channelValue==null){
          return false;
        }
        return this.channelDialogInfo.channelValue.toLowerCase().indexOf("sabre") >= 0;
      }
      return this.dataForm.channel.indexOf("sabre")>=0;
    },
    getDataFormBookingChannel()
    {
      if(this.dataForm.channel == "-1"){
        if(this.channelDialogInfo.channelValue==undefined || this.channelDialogInfo.channelValue==null)
        {
          return false;
        }
        return this.channelDialogInfo.channelValue.toLowerCase().indexOf("booking") >= 0;
      }
      return this.dataForm.channel.indexOf("booking")>=0;
    },
    getCardTypeSelect() {
      return [
        { label: this.$t("cardTypes.IdCard"), value: "NI" },
        { label: this.$t("cardTypes.Passport"), value: "FOID" },
        { label: this.$t("cardTypes.HomeReturnPermit"), value: "RP" },
        { label: this.$t("cardTypes.TaiwanCard"), value: "TCC" },
        { label: this.$t("cardTypes.OfficerCard"), value: "JG" },
        { label: this.$t("cardTypes.HongKongAndMacaoPass"), value: "MP" },
        { label: this.$t("cardTypes.TaiWanPass"), value: "TWP" },
        { label: this.$t("cardTypes.HkAndMacauPass"), value: "GATJZZ" },
        { label: this.$t("cardTypes.ForeignPermanentResidentCard"), value: "PRC" },
      ];

    },
  },
  updated() {
    this.cardTypeOption = this.getCardTypeSelect;
  },
  watch: {
    "guestsDialogInfo.dialogAddGuest"(newVal) {
      if (!newVal) {
        this.$refs["addGuestInfo"].resetFields();
      }
    },
  },
  mounted() {
    this.initializationInfo();
    //判断来源 CRM、OBT跳转过来隐藏部分元素
    hideElement(this);
    // 根据view权限获取临客户信息
    //this.getCustomerList(1);
  },
  methods: {
   async getCharges (){
      let feeParams = {
        params: {
        customerCode:this.customerCodeChoosen,
        chargeType: this.chargeType,//类型 3 国内   20国际.
        paymeType: this.paymeType,//支付类型   1公付   2现付.
        serviceFeeType: "1",//1:线下.
        agreePriceType: this.agreePriceType,//协议价格类型 1: CP协议价  2: AP非协议价
        priceType:this.dataForm.priceType == "2" ? "cwt" : this.dataForm.priceType == "3" ? "agreementUser" : "",//协议价类型
        source:this.dataForm.channel == "-1" ? this.channelDialogInfo.channelValue : this.dataForm.channel,//渠道
        },
      };
      await getServiceCharge(feeParams).then((res)=>{
        if (res.code === 200) {
          getServerTimeAxios((date) => {
            var currentDate = date;
            let oldService=this.dataForm.servicefee;
            if(res.data.serviceFeeDetails.length > 0){
              res.data.serviceFeeDetails.some (item=>{ 
                if (item.startTime == ''){
                  item.startTime = "00:00";
                }
                if (item.endTime == ''){
                  item.endTime = "23:59";
                }
                var date = formatDateTime(currentDate, "YYYY-MM-DD");
                var stateTime = date + " " + item.startTime;
                var endTime = date + " " + item.endTime;
                var stateTimes = new Date(stateTime).getTime();
                var endTimes = new Date(endTime).getTime();
                var nowTimes = new Date(currentDate).getTime();
                if( stateTimes> endTimes){
                  var addCurrentTime = currentDate.setDate(currentDate.getDate()+1);
                  var addEndDate = formatDateTime(addCurrentTime, "YYYY-MM-DD");
                  var addEndTime = addEndDate + " " + item.endTime;
                  endTimes = new Date(addEndTime).getTime();
                }
                this.r2AppendChargeFeeType = item.r2AppendChargeFeeType;
                if(item.r2AppendChargeFeeType == 0){
                  this.advancepaymentMsg = this.$t('MANUAL.ADVANCEPAYMENT', {Type: "￥",});
                }
                else{
                  this.advancepaymentMsg = this.$t('MANUAL.ADVANCEPAYMENT', {Type: "%",});
                }
                this.dataForm.advancePayment = item.r2AppendChargeFee
                if(nowTimes >= stateTimes && nowTimes <= endTimes){
                  let servicefeeRaw=0;
                  if (item.ticketChargeMoneyType == "1" && item.ticketChargeMoney > 0)
                  {
                      let totalPriceRaw = this.orderStatus_Failed ? this.dataForm.prices.totalPrice : 0;
                      // 步骤1：强制转换为数字（非数字会转为 NaN）；步骤2：若转换结果为 NaN/undefined/null，兜底为 0
                      let totalPrice = Number(totalPriceRaw) ?? 0;
                      let servicefeeRaw = this.preciseRound(this.preciseRound(totalPrice * (item.ticketChargeMoney / 100) / 1.06, 2) * 1.06, 2);
                      if(servicefeeRaw!=oldService)
                      {
                        this.confirmFlag = true;
                        this.confirmMsg ='服务费已修改为:'+servicefeeRaw;
                      }
                      this.dataForm.servicefee =servicefeeRaw;
                      this.dataForm.urgentFee = item.ticketEmergencyMoney;
                  }
                  else
                  {
                      servicefeeRaw= item.ticketChargeMoney;
                      if(servicefeeRaw!=oldService)
                      {
                        this.confirmFlag = true;
                        this.confirmMsg ='服务费已修改为:'+servicefeeRaw;
                      }
                      this.dataForm.servicefee = item.ticketChargeMoney;
                      this.dataForm.urgentFee = item.ticketEmergencyMoney;
                  }
                  return true;
                }
                else
                {
                  this.dataForm.servicefee = 0;
                  this.dataForm.urgentFee = 0;
                }
              })
            }
          else{
            this.dataForm.advancePayment = 0;
            this.dataForm.servicefee = 0;
            this.dataForm.urgentFee = 0;
          } 
        });
        }
        else{
          this.dataForm.advancePayment = 0;
          this.dataForm.servicefee = 0;
          this.dataForm.urgentFee = 0;
        }
      }).catch((error)=>{
        console.log(error.objError);
      })
    },
    preciseRound(num, decimalPlaces) {
      // 处理非数字情况，避免报错
      if (isNaN(num)) return 0;
      const multiplier = Math.pow(10, decimalPlaces);
      // 利用 Math.round 实现“远离零”的四舍五入，解决 toFixed 的银行家舍入问题
      return Math.round(num * multiplier) / multiplier;
    },
    setConfirmFlag() {
      this.confirmFlag = false;
      if (this.orderIdTo != "") {
        this.$router.push({
          name: "Confirmation",
          query: { orderId: this.orderIdTo, sourceType: this.$objBaseInfo.sourceType, customerCode: this.clientDialogInfo.selectedCustomerCode },
        });
      }
    },
    //动态MI下拉框
    miDropChange(val1, item) {
      this.dataForm[item.relationMIKey] = val1;
      if (item.textTypeCode === "down") {
        let obj = item.dropDowns.find((e) => {
          return e.downCode === val1;
        });
        this.dataForm[item.relationMIKey + "Name"] =
          this.$i18n.locale == "zh" ? obj.miNameCN : obj.miNameEN;
      }
      this.$forceUpdate();
    },
    //MI信息获取
    async getMiList() {
      let miParams = {
        params: {
          flitProType: this.destinationType == "D" ? "JD" : "JI",
        },
      };
      if (this.clientDialogInfo.selectedCustomerCode) {
        miParams.params.customerCode = this.clientDialogInfo.selectedCustomerCode;
      }
      else {
        return;
      }
      await getCustomerMI(miParams).then((res) => {
        if (res.code === 200) {
          this.miList = [];
          const miListALl = res.data.items;
          if (miListALl.length > 0) {
            for (const key in miListALl) {
              const element = miListALl[key];
              if (element.pageShow === 1) {
                this.miList.push(element);
              }
              if (element.textTypeCode === "down") {
                for (const dropKey in element.dropDowns) {
                  const drop = element.dropDowns[dropKey];
                  if (drop.isDefault === 1) {
                    this.dataForm[element.relationMIKey] = drop.downCode;
                    break;
                  }
                }
              }
            }
          }
        }
      });
    },
    //获取出行人信息
    async getTraveler(currPage) {
      this.travelerloading = true;
      let tranlerParam = {
        params: {
          page: currPage,
          per_page: 5,
          travelerName: this.employeeDialogInfo.searchName,
          mobile: this.employeeDialogInfo.searchTel,
          staffNum: this.employeeDialogInfo.searchEmployeeID,
          email: this.employeeDialogInfo.searchEmail,
        },
      };
      if (this.clientDialogInfo.selectedCustomerCode) {
        tranlerParam.params.companyCode = this.clientDialogInfo.selectedCustomerCode;
      }
      else {
        this.travelerloading = false;
        return;
      }
      let that = this;
      await travelerLookup(tranlerParam)
        .then((res) => {
          if (res.data) {
            that.employeeDialogInfo.pagination.total = res.data.total; //总数
            that.employeeDialogInfo.pagination.pageSize = res.data.pageSize;
            that.employeeDialogInfo.pagination.currentPage = res.data.pageNumber;
            that.employeeDialogInfo.employeeData = res.data.travelerList;
          }
          this.travelerloading = false;
        })
        .catch(function (error) {
          this.travelerloading = false;
          console.log("出行人信息 请求失败", error.objError);
        });
    },

    //获取临客列表信息
    async getTemporaryGuestList(currPage) {
      this.tempUserloading = true;
      let temporaryGuestParam = {
        params: {
          page: currPage,
          per_page: 5,
          psgName: this.guestsDialogInfo.searchName,
          mobile: this.guestsDialogInfo.searchTel,
        },
      };
      if (!this.clientDialogInfo.selectedCustomerCode || !this.dataForm.contact.userId) {
        this.tempUserloading = false;
        return;
      }
      if (this.clientDialogInfo.selectedCustomerCode) {
        temporaryGuestParam.params.userCode = this.clientDialogInfo.selectedCustomerCode;
      }
      if (this.dataForm.contact.userId) {
        temporaryGuestParam.params.loginId = this.dataForm.contact.userId;
      }
      let that = this;
      await getTemporaryGuestList(temporaryGuestParam)
        .then((res) => {
          if (res.data) {
            that.guestsDialogInfo.pagination.total = res.data.total; //总数
            that.guestsDialogInfo.pagination.pageSize = res.data.pageSize;
            that.guestsDialogInfo.pagination.currentPage = res.data.pageNumber;
            that.guestsDialogInfo.guestsData = res.data.list;
          }
          this.tempUserloading = false;
        })
        .catch(function (error) {
          this.tempUserloading = false;
          console.log("临客信息 请求失败", error.objError);
        });
    },
     //获取港澳台consul配置
     async getCityConcelValue() {
      let Params = {
        params: {
          key: "CityCodes",
        },
      };
      await getConsul(Params)
        .then((res) => {
          if (res.code == 200) {
            this.CityCodes=res.message.split(',');
          }
        })
        .catch(function (error) {
          console.log("请求失败", error.objError);
        });
    },
    async getCustomerList() {
      let customerParam = {
        params: {
          page: 1,
          per_page: 5,
          customerCode: this.$objBaseInfo.poscode,
        },
      };
      let that = this;
      await getCustomerLookup(customerParam)
        .then((res) => {
          if(res.code==200){
            if(res.data.customerDetails.length>0){
              that.customerDetails = res.data.customerDetails[0];
            }
          }
        })
        .catch(function (error) {
          console.log("客户信息 请求失败", error.objError);
        });
    },
    //获取出差单列表信息
    async getTravelApplyOrderList(currPage) {
      this.approvedTripsloading = true;
      let travelApplyOrderParam = {
        params: {
          page: currPage,
          per_page: 5,
          isManualOrder: 1,
          tripPurpose: this.approvedTripsDialogInfo.approvedTripsReason,
        },
      };
      if (!this.clientDialogInfo.selectedCustomerCode || !this.dataForm.contact.userId) {
        this.approvedTripsloading = false;
        return;
      }
      if (this.approvedTripsDialogInfo.approvedTripsType == "1") {
        travelApplyOrderParam.params.tripOrderNo = this.approvedTripsDialogInfo.approvedTripsNo;
      }
      if (this.approvedTripsDialogInfo.approvedTripsType == "2") {
        travelApplyOrderParam.params.customerOrderNo = this.approvedTripsDialogInfo.approvedTripsNo;
      }
      if (this.clientDialogInfo.selectedCustomerCode) {
        travelApplyOrderParam.params.userCode = this.clientDialogInfo.selectedCustomerCode;
      }
      if (this.dataForm.contact.userId) {
        travelApplyOrderParam.params.userID = this.dataForm.contact.userId;
      }

      let that = this;
      await searchTravelApplyOrder(travelApplyOrderParam)
        .then((res) => {
          if (res.data) {
            that.approvedTripsDialogInfo.pagination.total = res.data.total; //总数
            that.approvedTripsDialogInfo.pagination.pageSize = 5;
            that.approvedTripsDialogInfo.pagination.currentPage = currPage;
            that.approvedTripsDialogInfo.approvedTripsData = [];
            for (const index in res.data.tripOrderList) {
              var item = res.data.tripOrderList[index];
              var object = {};
              object.triporderno = item.triporderno ? item.triporderno : "";
              object.customerOrderNo = item.customerOrderNo ? item.customerOrderNo : "";
              if (item.startDate && item.endDate) {
                object.approvedTripDate = formatDateTime(item.startDate, "YYYY-MM-DD") + "-" + formatDateTime(item.endDate, "YYYY-MM-DD");
              }
              object.tripPurpose = item.tripPurpose ? item.tripPurpose : "";
              object.locationNames = "";
              object.travelersNames = "";
              for (const locationIndex in item.location) {
                var name = item.location[locationIndex].locationName ? item.location[locationIndex].locationName : "";
                if (locationIndex == item.location.length - 1) {
                  object.locationNames = object.locationNames + name;
                }
                else {
                  object.locationNames = object.locationNames + name + ",";
                }
              }
              for (const travelersIndex in item.travelers) {
                var userName = item.travelers[travelersIndex].userName ? item.travelers[travelersIndex].userName : "";
                if (travelersIndex == item.travelers.length - 1) {
                  object.travelersNames = object.travelersNames + userName;
                }
                else {
                  object.travelersNames = object.travelersNames + userName + ",";
                }
              }
              that.approvedTripsDialogInfo.approvedTripsData.push(object);
            }
          }
          else {
            that.approvedTripsDialogInfo.approvedTripsData = [];
          }
          this.approvedTripsloading = false;
        })
        .catch(function (error) {
          console.log("出差单信息 请求失败", error.objError);
        });
    },
    //同步button
    async hotelAsync() {
      if(this.dataForm.hotel.hotelCode=="")
      {
        return;
      }
      let searchparams = {
        params: {
          hotelIds: this.dataForm.hotel.hotelCode,
        },
      };
      this.hotelloading = true;
      await getHotelList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.getRoomTypeList();
            this.hotelloading = false;
            this.confirmFlag = true;
            this.confirmMsg = "同步成功";
          } else {
            this.hotelloading = false;
            this.confirmFlag = true;
            this.confirmMsg = "同步失败";
          }
        })
        .catch(function (error) {
          console.log("酒店信息 请求失败", error.objError);
        });
    },
    //获取酒店列表信息
    async getHotelList(currPage,isJumpManual) {
      this.hotelloading = true;
      let hotelParam = {
        params: {
          page: currPage,
          per_page: 5,
          hotelName: this.hotelDialogInfo.searchHotelName,
          starRating: this.hotelDialogInfo.searchStarRating,
          contactNumber: this.hotelDialogInfo.searchContactTel,
        },
      };
      if(isJumpManual){
        hotelParam.params.hotelCode =this.hotelDialogInfo.hotelCode;
      }else{
        if (this.dataForm.city.countryCode) {
          hotelParam.params.countryCode = this.dataForm.city.countryCode;
        } else {
          this.hotelloading = false;
          return;
      }
      }
      let that = this;
      await getHotelLookup(hotelParam)
        .then((res) => {
          if (res.data) {
            that.hotelDialogInfo.pagination.total = res.data.pagination.totalItemCount; //总数
            that.hotelDialogInfo.pagination.pageSize = hotelParam.params.per_page;
            that.hotelDialogInfo.pagination.currentPage = res.data.pagination.page;
            that.hotelDialogInfo.hotelData = res.data.items;
          }
          this.hotelloading = false;
        })
        .catch(function (error) {
          this.hotelloading = false;
          console.log("酒店信息 请求失败", error.objError);
        });
    },

    //获取房型下拉框数据
    async getRoomTypeList(val) {
      let roomTypeParam = {
        params: {
          page: 1,
          per_page: 10,
        },
      };
      if (this.$objBaseInfo.poscode) {
        roomTypeParam.params.posCode = this.$objBaseInfo.poscode;
      }
      if (this.dataForm.hotel.hotelCode) {
        roomTypeParam.params.hotel_id = this.dataForm.hotel.hotelCode;
      }
      this.roomTypeList = [];
      if(!val){
        this.dataForm.roomType.roomTypeCode = "";
        this.dataForm.roomType.roomTypeName = "";
      }
      let that = this;
      await roomTypeList(roomTypeParam)
        .then((res) => {
          if (res.code == 200) {
            that.roomTypeList = res.data.items;
            if (res.data.error.code != 0) {
              // that.confirmFlag = true;
              // that.confirmMsg = that.$t("ERRORMESSAGE." + res.data.error.code) === "ERRORMESSAGE." + res.data.error.code ? that.$t("ERRORMESSAGE.NOTFOUND") : that.$t("ERRORMESSAGE." + res.data.error.code);

              console.log("获取房型下拉框数据 请求失败, code:" + res.data.error.code, res.data.error.message);
            }
          } else {
            // that.confirmFlag = true;
            // that.confirmMsg = that.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code ? that.$t("ERRORMESSAGE.NOTFOUND") : that.$t("ERRORMESSAGE." + res.code);
            console.log("获取房型下拉框数据 请求失败, code:" + res.code, res.message);
          }
        })
        .catch(function (error) {
          // that.confirmFlag = true;
          // that.confirmMsg = that.$t("ERRORMESSAGE." + error.mesCode);

          console.log("获取房型下拉框数据 请求失败", error.objError);
        });
    },
    addGuest() {
      this.$refs["addGuestInfo"].validate((valid) => {
        if (valid) {  
          this.guestsDialogInfo.dialogAddGuest = false; 
          if(this.isOtherGuest){
            this.dataForm.bookingFormOther.name = this.addGuestInfo.guestName;
            this.dataForm.bookingFormOther.mobile = this.addGuestInfo.guestMobile;
            this.dataForm.bookingFormOther.email = this.addGuestInfo.guestEmail;
            this.dataForm.bookingFormOther.birthday = "";
            this.dataForm.bookingFormOther.idCardNumber = "";
            this.dataForm.bookingFormOther.passportNumber = "";
            this.dataForm.bookingFormOther.visaCountry = "";
            this.dataForm.bookingFormOther.sex = "";
            this.dataForm.bookingFormOther.refId = this.dataForm.contact.RefId;
            this.dataForm.bookingFormOther.isEmployee = false;
            this.dataForm.bookingFormOther.travelerCode = this.dataForm.contact.userId;
            this.dataForm.bookingFormOther.showIdNumber = true;
            this.dataForm.bookingFormOther.lKPKID = 0;
            this.dataForm.bookingFormOther.isTemporary = true;
          }else{
            this.dataForm.traveler.travelerName = this.addGuestInfo.guestName;
            this.dataForm.traveler.mobile = this.addGuestInfo.guestMobile;
            this.dataForm.traveler.email = this.addGuestInfo.guestEmail;
            this.dataForm.traveler.birthday = "";
            this.dataForm.traveler.idCardNumber = "";
            this.dataForm.traveler.passportNumber = "";
            this.dataForm.traveler.visaCountry = "";
            this.dataForm.traveler.sex = "";
            this.dataForm.traveler.RefId = this.dataForm.contact.RefId;
            this.dataForm.traveler.isEmployee = false;
            this.dataForm.traveler.userId = this.dataForm.contact.userId;
            this.dataForm.traveler.showIdNumber = true;
            this.dataForm.traveler.lKPKID = 0;
            this.dataForm.traveler.isTemporary = true;
            this.LoadCostCenter();//选择完入住人后再加载成本中心
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    submitBooking: function () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.isSubmit=false;
          var deadlineDay = -1;
          if (this.dataForm.cancellationRules.cancellationPolicy == 2) {
            deadlineDay = this.getDayDiff(this.dataForm.cancellationRules.deadlineDate, this.dataForm.checkinDate);
            if (deadlineDay < 0) {
              this.confirmFlag = true;
              this.confirmMsg = this.$t("MANUAL.VALIDATECANCELDATETIPS");
              this.isSubmit=true;
              this.submitLoading = false;
              return false;
            }
          }
          if(this.dataForm.paymentStatus == "4" || this.dataForm.settlementMethod == "3"){//选择公付
            if(this.$objBaseInfo.openResource){//验证选择的企业是否开启了公付
              let cityInfos = this.dataForm.city;
              var data = JSON.parse(this.$objBaseInfo.openResource);
              if(this.destinationType === "I" && !data.International.includes("3")){
                this.confirmFlag = true;
                this.confirmMsg = this.$t("MANUAL.VALIDATEPAYMENTSTATUSPUBLIC",{mode:"国际"});
                this.isSubmit=true;
                this.submitLoading = false;
                return false;
              }
              if (cityInfos && cityInfos != {} && this.destinationType === "D") {
                if(isCityGAT(cityInfos.provinceCode)){
                  if(!data.GangAoTai.includes("3")){
                    this.confirmFlag = true;
                    this.confirmMsg = this.$t("MANUAL.VALIDATEPAYMENTSTATUSPUBLIC",{mode:"港澳台"});
                    this.isSubmit=true;
                    this.submitLoading = false;
                    return false;
                  }
                }else{
                  if(!data.Domestic.includes("3")){
                    this.confirmFlag = true;
                    this.confirmMsg = this.$t("MANUAL.VALIDATEPAYMENTSTATUSPUBLIC",{mode:"国内"});
                    this.isSubmit=true;
                    this.submitLoading = false;
                    return false;
                  }
                }
              } 
            }
            if(this.dataForm.isShowOtherGuest){
              this.confirmFlag = true;
              this.confirmMsg = this.$t("MANUAL.VALIDATEOTHERGUESTPAYMENT");
              this.isSubmit=true;
              this.submitLoading = false;
              return false;
            }
          }
          let miParamList = [];
          //MI信息参数
          for (const key in this.miList) {
            const element = this.miList[key];
            let miParam = {
              miType: 2,
              miNameDic: {
                en: "",
                "zh-CN": "",
              },
            };
            miParam.miNameDic["en"] = element.miNameEN;
            miParam.miNameDic["zh-CN"] = element.miNameCN;
            miParam.miKey = element.relationMIKey;
            if (element.textTypeCode == "down") {
              miParam.miValue = this.dataForm[element.relationMIKey];
              miParam.miCode = this.dataForm[element.relationMIKey + "Name"];
            } else {
              miParam.miValue = this.dataForm[element.relationMIKey];
              miParam.miCode = "";
            }

            miParam.noteCN = element.noteCN;
            miParam.noteEN = element.noteEN;
            miParam.noteCNLink = element.noteCNLink;
            miParam.noteENLink = element.noteENLink;
            miParam.miGuid=element.miGuid;
            miParam.isSendHotelItinerary = element.isSendHotelItinerary;
            miParam.isAffterHotelApproval=element.isAffterHotelApproval;
            miParamList.push(miParam);
          }
          //成本中心判断
          if(this.isCostCenterOpen)//判断是否打开成本中心
          {
            //判断是否存在成本中心
            if(this.CostCenterList.length==0)
            {
              this.confirmFlag = true;
              this.confirmMsg =this.$t("BOOKING.CostCenterTitle2");
              this.submitLoading = false;
              return;
            }

            //判断是否选择成本中心
            if(this.dataForm.costCenterid==0)
            {
              this.confirmFlag = true;
              this.confirmMsg =this.$t("BOOKING.CostCenterTitle1");
              this.submitLoading = false;
              this.isSubmit=true;
              return;
            }
            if(this.isValidUATP)//判断是否验证UATP卡卡号
            {
              if(this.dataForm.uatpCardNo=="")
              {
                this.confirmFlag = true;
                this.confirmMsg =this.$t("BOOKING.CostCenterUATPTitle1");
                this.submitLoading = false;
                this.isSubmit=true;
                return;
              }
              if (!this.isopenCTA) {
                if (this.dataForm.uatpCardValidDate == "")//判断是否存在有效期
                {
                  this.confirmFlag = true;
                  this.confirmMsg = this.$t("BOOKING.CostCenterUATPTitle1");
                  this.submitLoading = false;
                  this.isSubmit = true;
                  return;
                }
                if (!this.isValidExpiredUATP) {
                  this.confirmFlag = true;
                  this.confirmMsg = this.$t("BOOKING.CostCenterUATPTitle2");
                  this.submitLoading = false;
                  this.isSubmit = true;
                  return;
                }
              }
              
            }
            // else//不验证成本中心的话需要判断有效期是否存在
            // {
            //   if(this.dataForm.uatpCardNo!="")
            //   {
            //     if(this.dataForm.uatpCardValidDate=="")//判断是否存在有效期
            //     {
            //       this.confirmFlag = true;
            //       this.confirmMsg =this.$t("BOOKING.CostCenterUATPTitle1");
            //       this.submitLoading = false;
            //       this.isSubmit=true;
            //       return;
            //     }
            //   }
            // }
          }
          var extendArray = [];
          
          if (this.dataForm.hasOwnProperty("extendArray")) 
          {
              for(let i=0;i<this.dataForm.extendArray.length;i++)
              {
                extendArray.push(this.dataForm.extendArray[i]);
              }
          }
          if (this.dataForm.remark) {
            extendArray.push({ Name: "Remark", ValueInfo: [{ "en": this.dataForm.remark, "zh-CN": this.dataForm.remark }] });
          }
          if (this.dataForm.smoking == "Y") {
            extendArray.push({ Name: "Special", ValueInfo: [{ "en": "Smoking Room", "zh-CN": "吸烟房" }] });
          }
          if (this.dataForm.smoking == "N") {
            extendArray.push({ Name: "Special", ValueInfo: [{ "en": "Non-smoking Room", "zh-CN": "无吸烟房" }] });
          }
          if (this.dataForm.smoking == "U") {
            extendArray.push({ Name: "Special", ValueInfo: [{ "en": "Unknow", "zh-CN": "未知" }] });
          }
          if(this.$objBaseInfo.intlTaxDisplay){
            extendArray.push({ Name: "intlTaxDisplayInfo", ValueInfo: [{ "intlTaxDisplay": this.$objBaseInfo.intlTaxDisplay }] });
          }
          if(Object.prototype.hasOwnProperty.call(this.dataForm.city, "countryCode")){
            extendArray.push({ Name: "countryCode", ValueInfo: [{ "countryCode": this.dataForm.city.countryCode }] });
          }
          //垫资费
          if(this.dataForm.settlementMethod == "3"){//公付
            if(this.r2AppendChargeFeeType != 0)
            {
              this.dataForm.advancePayment = (this.dataForm.advancePayment * this.dataForm.prices.totalPrice * 0.01).toFixed(2);
            }
          }
          else{
            this.dataForm.advancePayment = 0;
          }
          var itineraryLanguage = this.dataForm.contact.languageValue == "CN" ? "zh-CN" : this.dataForm.contact.languageValue;
          if(this.$objBaseInfo.itineraryLanguageSet){
            var data = JSON.parse(this.$objBaseInfo.itineraryLanguageSet);
            //if(data.Type == "2"){
              if(this.destinationType == "I"){
              if(data.AreaItem.International == "1"){
                itineraryLanguage = "zh-CN";
              }else if(data.AreaItem.International == "2"){
                itineraryLanguage = "en";
              }
              //itineraryLanguage = data.AreaItem.International == "1" ?"zh-CN" :"en";
              }
              if(this.destinationType == "D"){
                if(isCityGAT(this.dataForm.city.provinceCode)){
                if(data.AreaItem.GangAoTai == "1"){
                  itineraryLanguage = "zh-CN";
                }else if(data.AreaItem.GangAoTai == "2"){
                  itineraryLanguage = "en";
                }
                //itineraryLanguage = data.AreaItem.GangAoTai == "1" ?"zh-CN" :"en";
                }else{
                if(data.AreaItem.Domestic == "1"){
                  itineraryLanguage = "zh-CN";
                }else if(data.AreaItem.Domestic == "2"){
                  itineraryLanguage = "en";
                }
                //itineraryLanguage = data.AreaItem.Domestic == "1" ?"zh-CN" :"en";
              }
            }
            //}
          }
          let customerPhone="";
          //elong渠道的订单 获取服务组电话 规则：linkType=1  
          let isdomc=this.destinationType;//获取国内国际
          if(this.CityCodes.length>0 && this.CityCodes.indexOf(this.dataForm.city.cityCode)>=0)//港澳台城市当作国内城市判断
          {
            isdomc="I";
          }
          if(this.customerDetails!=undefined && this.customerDetails.customerTcs!=undefined &&this.customerDetails.customerTcs!=null)
          {
            let customerTcsArr=this.customerDetails.customerTcs.filter(item=>item.linkType==1 && item.isDomc.indexOf(isdomc)>=0);
            if(customerTcsArr.length>0)
            {
              if(customerTcsArr.length==1)
              {
                customerPhone=customerTcsArr[0].keyValue;
              }
              else if(customerTcsArr.length>1)
              {
                customerTcsArr=customerTcsArr.sort((a,b)=>{ return a.sortId-b.sortId});
                customerPhone=customerTcsArr[0].keyValue;
              }
            }
          }
          let contactLinkInfo = null;
          if(this.dataForm.showLinker){
            contactLinkInfo = {
              name: this.dataForm.traveler.linkerName,
              mobile: this.dataForm.traveler.linkerMobile,
              email: this.dataForm.traveler.linkerEmail,
            };
          }
          //创建订单请求参数
          let bookParam = {
            creationTime: new Date().valueOf(),
            poscode: this.$objBaseInfo.poscode,
            customerId: this.dataForm.customer.customerId,
            customerName: this.dataForm.customer.customerName,
            costCenterid:this.dataForm.costCenterid,//成本中心id
            bookingAgents: [
              {
                type: this.dataForm.contact.type,
                name: this.dataForm.contact.contactName,
                userId: this.dataForm.contact.userId,
                level: this.dataForm.contact.userLevel,
                departmentCode: this.dataForm.contact.departmentCode,
                departmentName: this.dataForm.contact.departmentName,
                contact: {
                  email: this.dataForm.contact.contactEmail,
                  mobile: this.dataForm.contact.contactMobile
                },
              },
              {
                type: "3",
                name: this.$objBaseInfo.userName,
                userId: this.$objBaseInfo.loginID,
                level: this.$objBaseInfo.userLevel,
                departmentCode: this.$objBaseInfo.departmentCode,
                departmentName: this.$objBaseInfo.departmentName,
                contact: {
                  email: "",
                  mobile: "",
                },
                manualOrderCreateUserId:this.ManualOrderCreateUserId,
                manualOrderCreate:this.ManualOrderCreate,
              },
            ],
            roomGuests: [
              {
                name: this.dataForm.traveler.travelerName,
                userId: this.dataForm.traveler.userId,
                refId: this.dataForm.traveler.RefId,
                isEmployee: this.changeGuestCheckBox ? this.dataForm.traveler.isEmployee : this.changeGuestCheckBox,
                guestLevel: this.dataForm.traveler.isEmployee ? this.dataForm.traveler.userLevel : this.dataForm.contact.userLevel,
                departmentCode: this.dataForm.traveler.isEmployee ? this.dataForm.traveler.departmentCode : this.dataForm.contact.departmentCode,
                departmentName: this.dataForm.traveler.isEmployee ? this.dataForm.traveler.departmentName : this.dataForm.contact.departmentName,
                birthday:this.dataForm.traveler.birthday,
                idCardNumber:this.dataForm.traveler.idCardNumber,
                passportNumber:this.dataForm.traveler.passportNumber,
                visaCountry:this.dataForm.traveler.visaCountry,
                sex:this.dataForm.traveler.sex,
                contact: {
                  email: this.dataForm.traveler.email,
                  mobile: this.dataForm.traveler.mobile,
                  linkerInfo: contactLinkInfo? JSON.stringify(contactLinkInfo) : "",
                },
                mi: {},
                isMajorTravelers:true,
              },
            ],
            approvedTrip: {
              systemTripNo: this.dataForm.approvedTrips.systemTripNo,
              customerTripNo: this.dataForm.approvedTrips.customerTripNo
            },
            hotelConfirmationNo: this.dataForm.hotelConfirm,
            sourceBookingId: this.dataForm.suppilerOrder,
            cityCode: this.dataForm.city.cityCode,
            hotelAddress: this.dataForm.hotel.addressAll,
            hotelContact: this.dataForm.hotel.contactNumber,
            bookingStatus: this.dataForm.orderStatus,
            isOutOfPolicy: this.dataForm.isOutOfPolicy,
            checkInDate: formatDateTime(this.dataForm.checkinDate,"YYYY-MM-DD"),
            checkOutDate: formatDateTime(this.dataForm.checkOutDate,"YYYY-MM-DD"),
            paymentInfo: {
              PaymentType: this.dataForm.settlementMethod,
              Paymentstatus: this.dataForm.paymentStatus,
              airplusUatp: this.dataForm.uatpCardNo,//uatp卡卡号
              airplusUatpvalidYearMonth: this.dataForm.uatpCardValidDate,//uatp卡有效期
              uATPSupplierAndModel : this.dataForm.supplierAndModel,//uatp卡供应商及模式
            },
            priceType: this.dataForm.priceType == "2" || this.dataForm.priceType == "3" ? "0" : "1",
            priceOwner: this.dataForm.priceType == "2" ? "cwt" : this.dataForm.priceType == "3" ? "agreementUser" : "",
            rateAccessCode: this.dataForm.rateAccessCode,
            isCPHotel: this.dataForm.hotelType == "2" ? true : false,
            isAPHotel: this.dataForm.hotelType == "1" ? true : false,
            serviceFees: {
              amount: this.dataForm.servicefee,
              currencyCode: "",
            },
            hotelCode: this.dataForm.hotel.hotelCode,
            hotelNames: this.dataForm.hotel.hotelNameAll,
            // HotelNames:{
            //   "en":this.dataForm.hotel.hotelNameEN,
            //   "zh-CN":this.dataForm.hotel.hotelName,
            // },
            breakfastQty: this.dataForm.breakfast,
            roomTypeCode: this.dataForm.roomType.roomTypeCode,
            roomTypeName: this.dataForm.roomType.roomTypeNameAll,
            extend: extendArray,
            source: this.dataForm.channel == "-1" ? this.channelDialogInfo.channelValue : this.dataForm.channel,
            currencyCode: this.dataForm.currencyCode,
            totalPrice: this.orderStatus_Failed ? this.dataForm.prices.totalPrice : 0,
            dailyPrices: this.orderStatus_Failed ?this.dataForm.prices.dailyPrices : [],
            taxes: {
              amount: this.dataForm.taxes?this.dataForm.taxes.toString():null,
              currencyCode: this.dataForm.currencyCode,
            },
            fees: {
              amount: this.dataForm.fees?this.dataForm.fees.toString():null,
              currencyCode: this.dataForm.currencyCode,
            },
            miInfoList: miParamList,
            guaranteeType: this.dataForm.guaranteeType,
            reservationType: this.dataForm.guaranteeType == "1" || this.dataForm.guaranteeType == "2" ? "0" : "1",

            cancellationRules: {
              cancellationPolicy: this.dataForm.cancellationRules.cancellationPolicy,
              deadlineDay: deadlineDay != -1 ? deadlineDay : null,
              deadlineTime: this.dataForm.cancellationRules.deadlineTime
            },
            sessionInfo: {
              languageCode: itineraryLanguage,
              bookingChannel: "CRM",
            },
            fxHotelCityInfo:{
              cityCode: this.dataForm.fxHotelCityInfo.cityCode,
              cityName: this.dataForm.fxHotelCityInfo.cityName,
              provinceName: this.dataForm.fxHotelCityInfo.provinceName,
              countryName: this.dataForm.fxHotelCityInfo.countryName,
            },
            //tdd
            ratePlanCode: null,
            ratePlanName: "", 
            roomCount: 1,
            arrivalTime: this.dataForm.arrivalTimeInfo.latestArrivalTime,
            isForeignerAllowed: false,
            isManualOrder: true,
            star: this.dataForm.starRating.toString(),
            group: this.dataForm.hotel.group.toString(),
            latitude: this.dataForm.hotel.latitude.toString(),
            longitude: this.dataForm.hotel.longitude.toString(),
            emergencyServiceFee:this.dataForm.urgentFee.toString(),
            advancePayment: this.dataForm.advancePayment.toString(),
            isInternational: this.destinationType === "I" ? true :false,
            customerPhone:customerPhone,
            isRepeat:this.isRepeat,//是否重单
            BookingCodeManualOrder:this.dataForm.BookingCodeManualOrder,//补单列表生成的订单号
            clientOrderNo:this.dataForm.ClientOrderNo,//补单列表生成的订单号
          };
          if(this.dataForm.isShowOtherGuest)//判断是否多人出行
          {
            let linkInfo = null;
            if(this.dataForm.showLinker){
              linkInfo = {
                name: this.dataForm.bookingFormOther.linkerName,
                mobile: this.dataForm.bookingFormOther.linkerMobile,
                email: this.dataForm.bookingFormOther.linkerEmail,
              };
            }
            let gustInfo={
                name: this.dataForm.bookingFormOther.name,
                userId: this.dataForm.bookingFormOther.travelerCode,
                refId: this.dataForm.bookingFormOther.refId ? this.dataForm.bookingFormOther.refId :this.dataForm.traveler.RefId,
                guestLevel: this.dataForm.bookingFormOther.userLevel,
                departmentCode: this.dataForm.bookingFormOther.departmentCode,
                departmentName: this.dataForm.bookingFormOther.departmentName,
                isEmployee:this.changeGuestCheckBox ? this.dataForm.bookingFormOther.isEmployee : this.changeGuestCheckBox,
                birthday:this.dataForm.bookingFormOther.birthday,
                idCardNumber:this.dataForm.bookingFormOther.idCardNumber,
                passportNumber:this.dataForm.bookingFormOther.passportNumber,
                visaCountry:this.dataForm.bookingFormOther.visaCountry,
                sex:this.dataForm.bookingFormOther.sex,
                contact: {
                  email: this.dataForm.bookingFormOther.email,
                  mobile: this.dataForm.bookingFormOther.mobile,
                  linkerInfo: linkInfo? JSON.stringify(linkInfo):"",
                },
                isMajorTravelers:false,
            }
            if(gustInfo.refId==bookParam.roomGuests[0].refId && gustInfo.name==bookParam.roomGuests[0].name)
            {
              this.confirmFlag = true;
              this.confirmMsg =this.$t("BOOKING.OTHERTITLEREPORT");;
              this.submitLoading = false;
              this.isSubmit=true;
              return;
            }
            bookParam.roomGuests.push(gustInfo);
          }

          let cityInfo = this.dataForm.city;
          if (cityInfo && cityInfo != {}) {
            bookParam.cityName = cityInfo.cityNameLists;
            bookParam.country = cityInfo.countryNameLists;
            bookParam.province = cityInfo.provinceNameLists;
            bookParam.tCCode = cityInfo.tcCode;
          } else {
            console.log("城市信息获取失败");
          }
          this.submitLoading = true;
          
          //调用创建订单的接口
          createBooking(bookParam)
            .then(async (res) => {
              this.submitLoading = false;
              if (res.code === 200) {
                if (codeIsCode(res.data.error.code)) {
                  //预定失败 需要跳转
                  this.orderIdTo = res.data.bookingId;
                  this.confirmMsg =
                    this.$t("ERRORMESSAGE.BOOKINGFAILED") +
                    (this.$t("ERRORMESSAGE." + res.data.error.code) ===
                    "ERRORMESSAGE." + res.data.error.code
                      ? this.$t("ERRORMESSAGE.NOTFOUND")
                      : this.$t("ERRORMESSAGE." + res.data.error.code));
                  this.confirmFlag = true;
                }
                else if (res.data.error.code != 0) 
                {
                   if(res.data.error.isMapping==true)
                    {
                      this.confirmMsg =res.data.error.message;
                      this.confirmFlag = true;
                    }
                    else
                    {
                      this.confirmFlag = true;
                      this.confirmMsg =
                        this.$t("ERRORMESSAGE." + res.data.error.code) ===
                        "ERRORMESSAGE." + res.data.error.code? this.$t("ERRORMESSAGE.NOTFOUND"): this.$t("ERRORMESSAGE." + res.data.error.code);
                    }
                }
                else 
                {
                  if(res.data.tradeResponse.code=="0")
                  {
                    await this.saveManualInfo(res.data.bookingId);
                    this.$router.push({
                      name: "Confirmation",
                      query: { orderId: res.data.bookingId, sourceType:this.$objBaseInfo.sourceType, customerCode: this.clientDialogInfo.selectedCustomerCode },
                    });
                  }
                  else
                  {
                    this.confirmMsg ="补单成功,支付服务费失败,失败原因:"+res.data.tradeResponse.msg
                    this.confirmFlag = true;
                  }
                }
              }
              else if (res.code === 500) {
                this.isSubmit=true;
                this.confirmFlag = true;
                if(res.message=="ORDER501")
                {
                  this.confirmMsg = this.$t("ERRORMESSAGE.ORDER501");
                }
                else
                {
                  this.confirmMsg = this.$t("ERRORMESSAGE.ORDER500");
                }
                console.log("创建订单失败,code:" + res.code, res.message);
              }
              else {
                this.isSubmit=true;
                this.confirmFlag = true;
                this.confirmMsg = this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code ? this.$t("ERRORMESSAGE.NOTFOUND") : this.$t("ERRORMESSAGE." + res.code);
                console.log(this.$t("MANUAL.ORDERCREATEDEXCEPTIONTIPS") + ", code:" + res.code, res.message);
              }
            })
            .catch((err) => {
              this.isSubmit=true;
              this.submitLoading = false;
              this.confirmFlag = true;
              this.confirmMsg = this.$t("ERRORMESSAGE." + err.mesCode);
              console.log(this.$t("MANUAL.ORDERCREATEDEXCEPTIONTIPS"), err.objError);
            });

        } else {
          this.submitLoading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 子组件赋值目的城市 destination组件
    setDestination(value) {
      if(value.cityCode  != ''){
        this.destinationType = value.cityInfo.destinationType;
        if(value.cityInfo.destinationType == "I"|| this.provinceCode.indexOf(value.cityInfo.provinceCode) >-1){
            this.showTaxes = true;
            this.chargeType = "20";
        }else{
            this.showTaxes = false;
            this.chargeType = "3";
        }
     
        if (this.$i18n.locale == 'zh' && this.dataForm.customer.strongControl == "1" && this.dataForm.approvedTrips.location && this.dataForm.approvedTrips.location.indexOf(value.cityName) < 0 && this.dataForm.city.cityName != value.cityName) {
          this.confirmFlag = true;
          this.buttonMsg = true;
          this.confirmMsg = this.$t("MANUAL.VALIDATEAPPROVEDTRIPANDCITY");
        }
        if (this.dataForm.city.cityName != value.cityName) {
          this.dataForm.hotel.hotelCode = "";
          this.dataForm.hotel.hotelName = "";
          this.dataForm.hotel.hotelNameEN = "";
          this.dataForm.starRating = "";
          this.dataForm.telFax = "";
          this.dataForm.address = "";
          this.roomTypeList = [];
          this.dataForm.roomType.roomTypeCode = "";
          this.dataForm.roomType.roomTypeName = "";
          this.dataForm.city.cityCode = value.cityCode;
          //this.getHotelList(1);
        }
        this.dataForm.city = value.cityInfo;
        this.dataForm.city.cityName = value.cityName;
        this.getCharges();
      }else{
        this.dataForm.city.cityName = "";
        return;
      }
      this.getMiList();
      this.$refs["dataForm"].validateField('city.cityName');
    },
    //员工列表分页切换
    pageChange_employeeDialog(currPage) {
      this.getTraveler(currPage);
    },
    //临客列表分页切换
    pageChange_guestsDialog(currPage) {
      this.getTemporaryGuestList(currPage);
    },
    //出差单列表分页切换
    pageChange_travelApplyOrderDialog(currPage) {
      this.getTravelApplyOrderList(currPage);
    },
    //酒店列表分页切换
    pageChange_hotelDialog(currPage) {
      this.getHotelList(currPage,false);
    },
    // 弹出客户姓名窗口方法
    showClientNamePop() {
      this.clientListFlag = true;
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
    // 弹出联系人姓名窗口方法
    showContactNamePop() {
      this.employeeDialogInfo.userActiveName = "first";
      this.employeeDialogInfo.dialogUserName = true;
      this.guestsDialogInfo.isShowTempGuest = false;
    },
    // 弹出入住人姓名窗口方法
    showTravelerNamePop(val) {
      this.employeeDialogInfo.userActiveName = "first";
      this.employeeDialogInfo.dialogUserName = true;
      this.guestsDialogInfo.isShowTempGuest = true;
      this.isOtherGuest = false;
      if(val == "other"){
        this.isOtherGuest = true;
      }
    },
    // 弹出出差单窗口方法
    showApprovedTripsPop() {
      this.approvedTripsDialogInfo.dialogApprovedTrips = true;
    },

    // 弹出酒店名窗口方法
    showHotelNamePop() {
      this.hotelDialogInfo.dialogHotel = true;
    },

    //选择客户
    selectClient(item) {
      if (this.clientDialogInfo.selectedCustomerCode != item.customerCode) {
        this.dataForm.contact.contactName = "";
        this.dataForm.contact.contactMobile = "";
        this.dataForm.contact.contactEmail = "";
        this.dataForm.traveler.travelerName = "";
        this.dataForm.traveler.mobile = "";
        this.dataForm.traveler.email = "";
        this.dataForm.traveler.birthday = "";
        this.dataForm.traveler.idCardNumber = "";
        this.dataForm.traveler.passportNumber = "";
        this.dataForm.traveler.visaCountry = "";
        this.dataForm.traveler.sex = "";
        this.dataForm.traveler.linkerName = "";
        this.dataForm.traveler.linkerMobile = "";
        this.dataForm.traveler.linkerEmail = "";
        this.dataForm.traveler.cardType = "NI";//证件类型
        this.dataForm.traveler.cardTypeNumber = "";
        this.dataForm.traveler.cardTypeSelectDisabled = false;
        this.dataForm.traveler.cardTypeButtonDisabled = false;
        this.dataForm.traveler.showIdNumber = false;
        this.dataForm.traveler.lKPKID = 0;
        this.dataForm.traveler.isTemporary = false;
        this.dataForm.approvedTrips.systemTripNo = "";
        this.dataForm.approvedTrips.customerTripNo = "";
        this.dataForm.servicefee = "";
        this.dataForm.bookingFormOther.name = "";
        this.dataForm.bookingFormOther.mobile = "";
        this.dataForm.bookingFormOther.email = "";
        this.dataForm.bookingFormOther.birthday = "";
        this.dataForm.bookingFormOther.idCardNumber = "";
        this.dataForm.bookingFormOther.passportNumber = "";
        this.dataForm.bookingFormOther.visaCountry = "";
        this.dataForm.bookingFormOther.sex = "";
        this.dataForm.bookingFormOther.linkerName = "";
        this.dataForm.bookingFormOther.linkerMobile = "";
        this.dataForm.bookingFormOther.linkerEmail = "";
        this.dataForm.bookingFormOther.cardType = "NI";//证件类型
        this.dataForm.bookingFormOther.cardTypeNumber = "";
        this.dataForm.bookingFormOther.cardTypeSelectDisabled = false;
        this.dataForm.bookingFormOther.cardTypeButtonDisabled = false;
        this.dataForm.bookingFormOther.showIdNumber = false;
        this.dataForm.bookingFormOther.lKPKID = 0;
        this.dataForm.bookingFormOther.isTemporary = false;
      }
      
      this.clientDialogInfo.selectedCustomerCode = item.customerCode;
      this.dataForm.customer.customerId = item.customerCode;
      this.dataForm.customer.customerName = item.customerName;
      this.dataForm.customer.ordApprovalType = item.ordApprovalType;
      this.dataForm.customer.strongControl = item.strongControl;
      this.dataForm.showLinker = item.linkerValue == 1 ? true : false;
      for (const key in item.customerFees) {
        const typeItem = item.customerFees[key];
        if (typeItem.serviceFeetype == 1) {
          this.dataForm.servicefee = typeItem.ticketChargemoney;
          break;
        }
      }
      // this.SETTLEMENTOPTION[2].disabled = !item.isCorpPay;//屏蔽公付
      // this.PAYMENTSTATUSOPTION[4].disabled = !item.isCorpPay;
      //替换全局的customerCode 、userCode、tc小组信息
      this.$objBaseInfo.userCode = item.customerCode;
      this.$objBaseInfo.customerCode = item.customerCode;
      this.$objBaseInfo.customerTcs = item.customerTcs;
      //获取poscode
      this.getPointSale(item.customerCode,false);
      //获取MI信息
      this.getMiList();
      // 根据view权限获取员工信息
      this.getTraveler(1);
      this.customerCodeChoosen = item.customerCode;
      this.getCharges();
      //console.log(item,'222222222222222');
    },
    //选择入住人或者联系人
    selectTraveler(item) {
      this.employeeDialogInfo.dialogUserName = false;
      if (this.guestsDialogInfo.isShowTempGuest) {
        if(this.isOtherGuest){
          this.dataForm.bookingFormOther.name = item.travelerName;
          this.dataForm.bookingFormOther.mobile = item.mobile;
          this.dataForm.bookingFormOther.email = item.email;
          this.dataForm.bookingFormOther.travelerCode = item.travelerCode;
          this.dataForm.bookingFormOther.userLevel = item.userLevel;
          this.dataForm.bookingFormOther.departmentCode = item.departmentID;
          this.dataForm.bookingFormOther.departmentName = item.departmentName;
          this.dataForm.bookingFormOther.refId = item.pkId;
          this.dataForm.bookingFormOther.isEmployee = true;
          this.dataForm.bookingFormOther.linkerName = item.linkerName;
          this.dataForm.bookingFormOther.linkerMobile = item.linkerMobilePhone;
          this.dataForm.bookingFormOther.linkerEmail = item.linkerEmail;
          this.dataForm.bookingFormOther.birthday = item.birthday? item.birthday : null;
          if(item.userPaperInfo.isComplete){
            this.dataForm.bookingFormOther.showIdNumber = false;
            this.dataForm.bookingFormOther.idCardNumber  = item.userPaperInfo.cardID ?? "";
            this.dataForm.bookingFormOther.passportNumber  = item.userPaperInfo.cardType ?? "";
            this.dataForm.bookingFormOther.visaCountry  = item.userPaperInfo.visaCountry ?? "";
          }else{
            this.dataForm.bookingFormOther.showIdNumber = true;
            this.dataForm.bookingFormOther.isTemporary  = false;
            this.dataForm.bookingFormOther.lKPKID  = 0;
          }
          this.dataForm.bookingFormOther.sex = item.sex? item.sex : null;

        }else{
          this.dataForm.traveler.travelerName = item.travelerName;
          this.dataForm.traveler.mobile = item.mobile;
          this.dataForm.traveler.email = item.email;
          this.dataForm.traveler.userId = item.travelerCode;
          this.dataForm.traveler.userLevel = item.userLevel;
          this.dataForm.traveler.departmentCode = item.departmentID;
          this.dataForm.traveler.departmentName = item.departmentName;
          this.dataForm.traveler.RefId = item.pkId;
          this.dataForm.traveler.isEmployee = true;
          this.dataForm.contact.languageValue = item.languageValue;
          this.dataForm.traveler.linkerName = item.linkerName;
          this.dataForm.traveler.linkerMobile = item.linkerMobilePhone;
          this.dataForm.traveler.linkerEmail = item.linkerEmail;
          this.dataForm.traveler.birthday = item.birthday? item.birthday : null;
          if(item.userPaperInfo.isComplete){
            this.dataForm.traveler.showIdNumber = false;
            this.dataForm.traveler.idCardNumber  = item.userPaperInfo.cardID ?? "";
            this.dataForm.traveler.passportNumber  = item.userPaperInfo.cardType ?? "";
            this.dataForm.traveler.visaCountry  = item.userPaperInfo.visaCountry ?? "";
          }else{
            this.dataForm.traveler.showIdNumber = true;
            this.dataForm.traveler.isTemporary  = false;
            this.dataForm.traveler.lKPKID  = 0;
          }
          this.dataForm.traveler.sex = item.sex? item.sex : null;
          this.LoadCostCenter();//选择完入住人后再加载成本中心
        }
      }
      else {
        if (this.dataForm.contact.userId != item.travelerCode) {
          this.dataForm.approvedTrips.systemTripNo = "";
          this.dataForm.approvedTrips.customerTripNo = "";
        }
        this.dataForm.contact.contactName = item.travelerName;
        this.dataForm.contact.contactMobile = item.mobile;
        this.dataForm.contact.contactEmail = item.email;
        this.dataForm.contact.userId = item.travelerCode;
        this.dataForm.contact.userLevel = item.userLevel;
        this.dataForm.contact.departmentCode = item.departmentID;
        this.dataForm.contact.departmentName = item.departmentName;
        //this.dataForm.contact.birthday = item.birthday? item.birthday : null;
        this.dataForm.contact.RefId = item.pkId;
        this.languageValue = item.languageValue;
        //临客使用预定人的语言偏好
        this.dataForm.contact.languageValue = item.languageValue;
        // 根据view权限获取临客信息
        this.getTemporaryGuestList(1);
        // 根据view权限获取出差单信息
        this.getTravelApplyOrderList(1);

        this.LoadCostCenter();//选择完预定人后先加载一遍成本中心
      }
    },
    //选择临客
    selectGuest(item) {
      this.employeeDialogInfo.dialogUserName = false;
      if(this.isOtherGuest){
        this.dataForm.bookingFormOther.name = item.psgName;
        this.dataForm.bookingFormOther.mobile = item.mobile;
        this.dataForm.bookingFormOther.email = item.email;
        this.dataForm.bookingFormOther.birthday = item.birthday? item.birthday : null;
        if(item.userPaperInfo.isComplete){
          this.dataForm.bookingFormOther.showIdNumber = false;
          this.dataForm.bookingFormOther.idCardNumber  = item.userPaperInfo.cardID ?? "";
          this.dataForm.bookingFormOther.passportNumber  = item.userPaperInfo.cardType ?? "";
          this.dataForm.bookingFormOther.visaCountry  = item.userPaperInfo.visaCountry ?? "";
        }else{
          this.dataForm.bookingFormOther.showIdNumber = true;
          this.dataForm.bookingFormOther.isTemporary  = true;
          this.dataForm.bookingFormOther.lKPKID  = item.pkId;
        }
        this.dataForm.bookingFormOther.idCardNumber = item.idCardNumber? item.idCardNumber : null;
        this.dataForm.bookingFormOther.passportNumber = item.passportNumber? item.passportNumber : null;
        this.dataForm.bookingFormOther.visaCountry = item.visaCountry? item.visaCountry : null;
        this.dataForm.bookingFormOther.sex = item.sex? item.sex : null;
        this.dataForm.bookingFormOther.refId = item.userID;
        this.dataForm.bookingFormOther.isEmployee = false;
        this.dataForm.bookingFormOther.travelerCode = item.loginId;
      }else{
        this.dataForm.traveler.travelerName = item.psgName;
        this.dataForm.traveler.mobile = item.mobile;
        this.dataForm.traveler.email = item.email;
        this.dataForm.traveler.birthday = item.birthday? item.birthday : null;
        if(item.userPaperInfo.isComplete){
          this.dataForm.traveler.showIdNumber = false;
          this.dataForm.traveler.idCardNumber  = item.userPaperInfo.cardID ?? "";
          this.dataForm.traveler.passportNumber  = item.userPaperInfo.cardType ?? "";
          this.dataForm.traveler.visaCountry  = item.userPaperInfo.visaCountry ?? "";
        }else{
          this.dataForm.traveler.showIdNumber = true;
          this.dataForm.traveler.isTemporary  = true;
          this.dataForm.traveler.lKPKID  = item.pkId;
        }
        this.dataForm.traveler.sex = item.sex? item.sex : null;
        this.dataForm.traveler.RefId = item.userID;
        this.dataForm.traveler.isEmployee = false;
        this.dataForm.contact.languageValue = this.languageValue;
        this.dataForm.traveler.userId = item.loginId;
        this.LoadCostCenter();//选择完入住人后再加载成本中心
      }
    },
    //选择出差单
    selectApprovedTrip(item) {
      this.approvedTripsDialogInfo.dialogApprovedTrips = false;
      this.dataForm.approvedTrips.systemTripNo = item.triporderno;
      this.dataForm.approvedTrips.customerTripNo = item.customerOrderNo;
      this.dataForm.approvedTrips.location = item.locationNames;
      if (this.$i18n.locale == 'zh' && this.dataForm.customer.strongControl == "1" && this.dataForm.approvedTrips.location && this.dataForm.approvedTrips.location.indexOf(this.dataForm.city.cityName) < 0) {
        this.confirmFlag = true;
        this.confirmMsg = this.$t("MANUAL.VALIDATEAPPROVEDTRIPANDCITY");
      }
    },

    //选择酒店
    async selectHotel(item) {
      this.hotelDialogInfo.dialogHotel = false;
      this.dataForm.hotel.hotelCode = item.id;
      this.dataForm.hotel.hotelName = item.name["zh-CN"];
      this.dataForm.hotel.hotelNameEN = item.name["en"];
      this.dataForm.starRating = item.starRating;
      this.dataForm.telFax = item.contactNumber;
      this.dataForm.address = item.address["zh-CN"];
      //保存中英文格式的酒店名称和地址 2022-01-16
      this.dataForm.hotel.addressAll = item.address;
      this.dataForm.hotel.hotelNameAll = item.name;
      this.dataForm.hotel.contactNumber = item.contactNumber;
      this.dataForm.hotel.group = item.group ? item.group.toString() : "";
      let localGeo = { latitude: "", longitude: "" };
      if (item.location) {
        localGeo = item.location.find(item => {
          if (item.geoType == "gps") {
            return item;
          }
        });
      }
      this.dataForm.hotel.latitude = localGeo.latitude;
      this.dataForm.hotel.longitude = localGeo.longitude;
      this.dataForm.fxHotelCityInfo.cityCode = item.city;
      this.dataForm.fxHotelCityInfo.cityName = item.cityName;
      this.dataForm.fxHotelCityInfo.provinceName = item.provinceName;
      this.dataForm.fxHotelCityInfo.countryName = item.countryName;
      
      //获取房型下拉框数据
      await this.getRoomTypeList();
    },

    //选择渠道
    channelDropChange() {
      this.channelDialogInfo.channel = "";
      this.channelDialogInfo.channelValue = "";
      if (this.dataForm.channel == "-1") {
        this.channelDialogInfo.dialogChannel = true;
      }
      this.getCharges();
    },
    //保存其它渠道
    saveOtherChannel() {
      this.channelDialogInfo.dialogChannel = false;
      this.channelDialogInfo.channelValue = this.channelDialogInfo.channel;
      this.$refs["dataForm"].validateField('channel', (valid) => { });
      this.getCharges();
    },

    cancellationPolicyChange() {
      if (this.dataForm.cancellationRules.cancellationPolicy != 2) {
        this.dataForm.cancellationRules.deadlineDate = null;
        this.dataForm.cancellationRules.deadlineTime = null;
      }
    },
    setRoomTypeName(item) {
      if (item) {
        this.dataForm.roomType.roomTypeName = item.name[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
        this.dataForm.roomType.roomTypeNameAll = item.name;
        this.RoomDescription=item.manualOrderDescription;
      }
    },
    savePriceDetails() {
      var totalPrice = 0;
      this.dataForm.prices.dailyPrices = [];
      let flage = 0;
      for (const key in this.dataForm.prices.dailyPricesDateData) {
        const element = this.dataForm.prices.dailyPricesDateData[key];
        var datePrice;
        datePrice = (this.dataForm[element] || this.dataForm[element] === 0) ? parseFloat(this.dataForm[element]) : undefined;
        if (typeof datePrice !== "undefined"){
          var dailyPrice = {
            StayDate: formatDateTime(element, "YYYY-MM-DD"),
            Price: datePrice.toString(),
            CurrencyCode: this.dataForm.currencyCode,
            PublishedFare: datePrice.toString(),
            // Taxs:{
            //   Amount:dataTax.toString(),
            //   CurrencyCode:this.dataForm.currencyCode,
            // },
            //   OtherFees:{
            //   Amount:dataOhters.toString(),
            //   CurrencyCode:this.dataForm.currencyCode,
            //   },
          };
          this.dataForm[element] = datePrice;
          totalPrice = parseFloat((totalPrice + datePrice).toFixed(2)); //totalPrice + datePrice;
          this.dataForm.prices.dailyPrices.push(dailyPrice);
          flage = flage + 1;
        }
      }
      if (flage == this.dataForm.prices.dailyPricesDateData.length) {
        this.dataForm.prices.totalPrice = totalPrice;
      } else {
        this.dataForm.prices.totalPrice = "";
      }
      this.dataForm.prices.isvisible = false;
      this.$refs["dataForm"].validateField('prices.dailyPrices', (valid) => { });
      this.getCharges();
    },

    //设置价格明细日期段
    setDailyPricesDateData() {
      if (!this.dataForm.checkOutDate || !this.dataForm.checkinDate) {
        return;
      }
      if(!this.dataForm.currencyCode)
      {
        this.confirmFlag = true;
        this.confirmMsg = this.$t("MANUAL.VALIDATECURRENCYCODE");
        this.dataForm.prices.isvisible = true;
        return;
      } 
      var endDate = new Date(this.dataForm.checkOutDate);
      endDate.setDate(endDate.getDate() - 1);
      var startDate = new Date(this.dataForm.checkinDate);
      var date_all = [];
      var i = 0
      while ((endDate.getTime() - startDate.getTime()) >= 0) {
        var year = startDate.getFullYear()
        var month = startDate.getMonth() + 1
        var day = startDate.getDate()
        date_all[i] = year + '/' + month + '/' + day
        startDate.setDate(startDate.getDate() + 1)
        i += 1
      }
      this.dataForm.prices.dailyPricesDateData = date_all;
      this.dataForm.prices.dailyPricesDateCount = Math.ceil(date_all.length / this.dataForm.prices.rowSize);
      // if ( this.dataForm.prices.dailyPricesDateData.length>1) {
      //   this.fullFlag = true;
      // }
    },

    //计算出相差天数
    getDayDiff(startDate, endDate) {
      if (!startDate || !endDate) {
        return -1;
      }
      var dateBegin = new Date(startDate);
      var dateEnd = new Date(endDate);
      var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
      var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
      return dayDiff;
    },
    clearNoNumTaxes(){
      this.dataForm.taxes = this.dataForm.taxes.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      this.dataForm.taxes = this.dataForm.taxes.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.dataForm.taxes = this.dataForm.taxes.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.dataForm.taxes = this.dataForm.taxes.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.dataForm.taxes = this.dataForm.taxes.replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.dataForm.taxes.indexOf(".") < 0 && this.dataForm.taxes != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.dataForm.taxes = parseFloat(this.dataForm.taxes);
      }
    },
    clearNoNumFees(){
      this.dataForm.fees = this.dataForm.fees.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      this.dataForm.fees = this.dataForm.fees.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.dataForm.fees = this.dataForm.fees.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.dataForm.fees = this.dataForm.fees.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.dataForm.fees = this.dataForm.fees.replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.dataForm.fees.indexOf(".") < 0 && this.dataForm.fees != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.dataForm.fees = parseFloat(this.dataForm.fees);
      }
    },
    //清除服务费非两位小数的值
    clearNoNumServicefee() {
      this.dataForm.servicefee = this.dataForm.servicefee.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      this.dataForm.servicefee = this.dataForm.servicefee.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.dataForm.servicefee = this.dataForm.servicefee.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.dataForm.servicefee = this.dataForm.servicefee.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.dataForm.servicefee = this.dataForm.servicefee.replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.dataForm.servicefee.indexOf(".") < 0 && this.dataForm.servicefee != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.dataForm.servicefee = parseFloat(this.dataForm.servicefee);
      }
    },
    //清除紧急服务费非两位小数的值
    clearNoNumUrgentfee() {
      this.dataForm.urgentFee = this.dataForm.urgentFee.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      this.dataForm.urgentFee = this.dataForm.urgentFee.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.dataForm.urgentFee = this.dataForm.urgentFee.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.dataForm.urgentFee = this.dataForm.urgentFee.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.dataForm.urgentFee = this.dataForm.urgentFee.replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.dataForm.urgentFee.indexOf(".") < 0 && this.dataForm.urgentFee != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.dataForm.urgentFee = parseFloat(this.dataForm.urgentFee);
      }
    },
    //清除房价总计非两位小数的值
    clearNoNumTotalPrice() {
      this.dataForm.prices.totalPrice = this.dataForm.prices.totalPrice.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      this.dataForm.prices.totalPrice = this.dataForm.prices.totalPrice.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.dataForm.prices.totalPrice = this.dataForm.prices.totalPrice.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.dataForm.prices.totalPrice = this.dataForm.prices.totalPrice.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.dataForm.prices.totalPrice = this.dataForm.prices.totalPrice.replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.dataForm.prices.totalPrice.indexOf(".") < 0 && this.dataForm.prices.totalPrice != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.dataForm.prices.totalPrice = parseFloat(this.dataForm.prices.totalPrice);
      }
    },

    //清除价格明细非两位小数的值
    clearNoNum(item) {
      console.log(item,'==============================');
      this.dataForm[item] = this.dataForm[item].replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      this.dataForm[item] = this.dataForm[item].replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.dataForm[item] = this.dataForm[item].replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.dataForm[item] = this.dataForm[item].replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.dataForm[item] = this.dataForm[item].replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.dataForm[item].indexOf(".") < 0 && this.dataForm[item] != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.dataForm[item] = parseFloat(this.dataForm[item]);
      }
      this.$forceUpdate();
    },
    //清除酒店确认号的中文
    clearHotelNoCN() {
      this.dataForm.hotelConfirm = this.dataForm.hotelConfirm.replace(/[^\x00-\xff]/g, ""); //清除中文
    },

    //验证渠道
    validateChannel(rule, value, callback) {
      if (this.dataForm.channel == "") {
        return callback(new Error(this.$t("MANUAL.VALIDATECHANNEL")));
      }
      else if (this.dataForm.channel == "-1" && (this.channelDialogInfo.channelValue == "" || this.channelDialogInfo.channelValue == undefined)) {
        return callback(new Error(this.$t("MANUAL.VALIDATECHANNELOTHER")));
      }
      else {
        return callback();
      }
    },
    //验证限时取消日期和时间
    validateDeadlineTime(rule, value, callback) {
      if (this.dataForm.cancellationRules.cancellationPolicy == "2" && (value == "" || value == null || this.dataForm.cancellationRules.deadlineTime == "")) {
        return callback(new Error(this.$t("MANUAL.VALIDATECANCELDATEONPOLICY")));
      }
      else {
        return callback();
      }
    },
    //验证离店日期
    validateCheckOutDate(rule, value, callback) {
      if (this.dataForm.checkOutDate == "" || this.dataForm.checkOutDate == null) {
        return callback(new Error(this.$t("MANUAL.VALIDATECHECKOUTDATE")));
      }
      else if (this.dataForm.checkinDate == "" || this.dataForm.checkinDate == null) {
        return callback();
      }
      else if (this.dataForm.checkOutDate < this.dataForm.checkinDate) {
        return callback(new Error(this.$t("MANUAL.VALIDATECHECKOUTDATEANDINDATE")));
      }
      else {
        return callback();
      }
    },

    //验证入住日期
    validateCheckInDate(rule, value, callback) {
      if (this.dataForm.checkinDate == "" || this.dataForm.checkinDate == null) {
        return callback(new Error(this.$t("MANUAL.VALIDATECHECKINDATE")));
      }
      else if (this.dataForm.checkOutDate == "" || this.dataForm.checkOutDate == null) {
        return callback();
      }
      else if (this.dataForm.checkOutDate < this.dataForm.checkinDate) {
        return callback(new Error(this.$t("MANUAL.VALIDATECHECKOUTDATEANDINDATE")));
      }
      else {
        return callback();
      }
    },
    //获取poscode
    getPointSale(customerCode,isShowOtherGuest) {
      let params = {
        params: { customerCode: customerCode },
      };
      let $this = this;
      pointSearch(params)
        .then(function (response) {
          //客户
          $this.$objBaseInfo.poscode = response.data.list[0] ? response.data.list[0].poscode : "";
          $this.$objBaseInfo.posCostCenterModel = response.data.list[0] ? response.data.list[0].posCostCenterModel : "";
          $this.$objBaseInfo.openResource = "";
          if(response.data.list[0].hotelSettings[0].hasOwnProperty("openResource"))
          {
            $this.$objBaseInfo.openResource = response.data.list[0].hotelSettings[0].openResource;
          }
          $this.$objBaseInfo.itineraryLanguageSet = response.data.list[0].hotelSettings[0].itineraryLanguageSet;
          $this.getCustomerList();
          $this.getCityConcelValue();
          $this.showButton = response.data.list[0].hotelSettings[0].maximumNumberAdultsAllowedRoom > 1;
          $this.dataForm.isShowOtherGuest = isShowOtherGuest;
        })
        .catch(function (error) {
          console.log("Point Sale 请求失败", error.objError);
        });
    },
    //修改日期时，清空总房价
    handleChangeDate(){
      this.dataForm.prices.totalPrice = "";
    },
      //判断是否重复预定
    verifyRepeatOrder(){
      this.isSubmit=false;
      this.isRepeat=false;
      this.submitLoading = true;
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params ={
              loginid: this.dataForm.traveler.isEmployee?this.dataForm.traveler.userId:this.dataForm.traveler.RefId,
              CheckInDate: formatDateTime(this.dataForm.checkinDate,"YYYY-MM-DD"),
              CheckOutDate: formatDateTime(this.dataForm.checkOutDate, "YYYY-MM-DD"),
              isEmployee: this.dataForm.traveler.isEmployee,
          }
          verifyRepeatOrder(params)
          .then((res) => {
            if (res.code === 200) {
              if (!res.data) {
                  this.submitLoading = true;
                  this.submitBooking();
              } else {
                  this.verifyRepeatOrderFlag=true;
              }
            } else {
              this.submitLoading = false;
              this.confirmFlag = true;
              this.confirmMsg =
                this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + res.code);
              console.log("验证重复订单错误, code:" + res.code, res.message);
            }
          })
          .catch((err) => { 
            this.submitLoading = false;
            console.log(err)
          });
        } else {
          this.submitLoading = false;
          this.isSubmit=true;
          return false;
        }
      });     
    },
    //重复订单弹框-取消
    CancelRepeatOrderConfirm()
    {
      this.verifyRepeatOrderFlag=false;
      this.submitLoading = false;

      this.isSubmit=true;
    },
    //重复订单弹框-继续
    continueRepeatOrderConfirm()
    {
      this.isRepeat=true;
      this.verifyRepeatOrderFlag=false;
      this.submitLoading = true;
      this.submitBooking();
    },
    //价格类型
    priceTypeChange() {
      this.agreePriceType = this.dataForm.priceType == "3" ? "1" : "2";
      this.getCharges();
      // if(this.dataForm.priceType == "1")
      // {
      //   this.dataForm.servicefee = 0;
      // }
      // else{
      //   this.agreePriceType = this.dataForm.priceType == "3" ? "1" : "2";
      //   this.getCharges();
      // }
    },
    paymeTypeChange() {
      this.showAdvancepayment = false;
      this.validateHotelNo = false;
      if(this.dataForm.settlementMethod == "2")
      {
        this.dataForm.servicefee = 0;
      }
      else{
        if(this.dataForm.settlementMethod == "3")
        {
          if(this.dataForm.orderStatus == 'BOOKED'){
            this.validateHotelNo = true;
          }
          this.showAdvancepayment = true;
        }
        this.paymeType = this.dataForm.settlementMethod == "1" ? "2" : "1";
        this.getCharges();
      }
      this.checkIsOpenOtherGuest();
    },
    //价格填充方法
    PriceFill()
    {
      let price=-1;
      for (const key in this.dataForm.prices.dailyPricesDateData) {
        const element = this.dataForm.prices.dailyPricesDateData[key];
        if(key=="0")
        {
          price=this.dataForm[element];
        }
        if(price==undefined || price==null || price==-1)
        {
          this.confirmFlag = true;
          this.confirmMsg ="请在第一行第一列输入价格";
          return;
        }
        console.log(this.dataForm[element]);
          var dailyPrice = {
          StayDate: formatDateTime(element, "YYYY-MM-DD"),
          Price: price,
          CurrencyCode: this.dataForm.currencyCode,
          PublishedFare: price,
        };
        if(this.dataForm[element]==undefined || this.dataForm[element]==null == this.dataForm[element]!="")
        {
          this.dataForm[element] = price;
          this.dataForm.prices.dailyPrices.push(dailyPrice);
        }
      }
      this.priceFlag++;
      this.getCharges();
    },
    //加载成本中心
    LoadCostCenter(){
      //判断是否存在成本中心配置
      if(Object.prototype.hasOwnProperty.call(this.$objBaseInfo,"posCostCenterModel"))
      {
        let posCostCenterModel=this.$objBaseInfo.posCostCenterModel;
        if(posCostCenterModel==undefined || posCostCenterModel==null || posCostCenterModel=="")
        {
          this.isCostCenterShow=false;
          this.dataForm.uatpCardNo = "";
          this.dataForm.uatpCardValidDate = "";
          this.dataForm.costCenterid = 0;
          this.isCostCenterOpen = false;
          return;
        }
        this.costCenterType=posCostCenterModel.selectedtype;
        if(posCostCenterModel.isopen==1)//是否开启成本中心
        {
          if(posCostCenterModel.isreq==1)
          {
            this.isCostCenterOpen=true;//打开成本中心--成本中心必填
          }
          this.GetCostCenterList();//获取成本中心列表
          if(posCostCenterModel.isview==1)
          {
            //展示成本中心
            this.isCostCenterShow=true;
          }
          else
          {
            //不展示成本中心
            this.isCostCenterShow=false;
          }
          if(posCostCenterModel.isuatp==1)
          {
            this.isValidUATP=true;
            //this.isValidExpiredUATP=false;
          }
          else
          {
            this.isValidUATP=false;
          }
        }
        else
        {
          this.dataForm.uatpCardNo = "";
          this.dataForm.uatpCardValidDate = "";
          this.dataForm.costCenterid = 0;
          //代表关闭
          this.isCostCenterOpen=false;
          //不显示成本中心
          this.isCostCenterShow=false;
        }
        console.log(this.$objBaseInfo.posCostCenterModel);
      }
    },
    // //获取UATP卡详情
    GetUATPDetails() {
      if(this.$objBaseInfo.posCostCenterModel.isOpenJICTA|| this.$objBaseInfo.posCostCenterModel.isOpenGATCTA || this.$objBaseInfo.posCostCenterModel.isOpenJDCTA)
      {
        this.isopenCTA=true;
        return;
      }
      let Params = {
        params: {
          cradNo: this.dataForm.uatpCardNo,
          userCode:this.$objBaseInfo.customerCode,
        },
      };
      let that=this;
      getuatp(Params)
        .then((res) => {
          if (res.code == 200) {
            let date=that.toValidate(res.data.expirationDate);
            const now = new Date();
            const monthStartDate = new Date(now.getFullYear(), now.getMonth(), 1);
            if (new Date(date) < monthStartDate) {
              if(that.isValidUATP)
              {
                that.confirmFlag = true;
                that.confirmMsg =that.$t("BOOKING.CostCenterUATPTitle2");
                that.isValidExpiredUATP=false;
              }
              else
              {
                that.dataForm.uatpCardValidDate=res.data.expirationDate;
                that.dataForm.supplierAndModel=res.data.supplierAndModel;
              }
            }
            else
            {
              that.dataForm.uatpCardValidDate=res.data.expirationDate;
              that.dataForm.supplierAndModel=res.data.supplierAndModel;
              that.isValidExpiredUATP=true;
            }
          }
          else
          {
             if(that.isValidUATP){
              that.confirmFlag = true;
              that.confirmMsg =this.$t("BOOKING.CostCenterUATPTitle1");
            }
          }
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    //成本中心下拉改变事件
    CostCenterChange(val) {

      let arr=this.CostCenterList.filter(p=>p.id==val);
      if(arr.length>0)
      {
        this.dataForm.uatpCardValidDate="";
        this.dataForm.costCenterid=0;
        this.dataForm.uatpCardNo="";
        this.dataForm.supplierAndModel="";
        let item=arr[0];
        if(Object.prototype.hasOwnProperty.call(this.$objBaseInfo,"posCostCenterModel"))
        {
          let posCostCenterModel=this.$objBaseInfo.posCostCenterModel;
          this.dataForm.costCenterid=item.id;
          this.dataForm.uatpCardNo=item.uatpno;
          if(posCostCenterModel.isuatp==1)
          {
            if(this.dataForm.uatpCardNo=="")
            {
              this.confirmFlag = true;
              this.confirmMsg =this.$t("BOOKING.CostCenterUATPTitle1");
            }
            else
            {
              this.GetUATPDetails();
            }
          }
          else
          {
            if(this.dataForm.uatpCardNo!="")
            {
              this.GetUATPDetails();
            }
          }
        }
      }
    },
       //信用卡有效期转换
    toValidate(validate) {
      if (validate) {
        //当年年份前两个字符
        const yyF = new Date().getFullYear().toString().substr(0, 2);
        if (validate.toString().length == 4) {
          //时间格式 MMYY
          const yyyyF = yyF + validate.toString().substr(2, 2);
          const mmF = validate.toString().substr(0, 2);
          return yyyyF + "-" + mmF + "-" + "01";
        } else if (
          validate.toString().length == 5 &&
          validate.toString().indexOf("/") > -1
        ) {
          //时间格式 MM/YY
          const dateArr = validate.split("/");
          return yyF + dateArr[1] + "-" + dateArr[0] + "-" + "01";
        } else if (
          //时间格式 yyyy-MM-ddThh:mm:ss.000Z
          validate.toString().indexOf("T") > -1
        ) {
          let shortDate = validate.toString().substr(0, 10);
          return shortDate;
        } else {
          console.log("信用卡有效期：", validate);
        }
      } else {
        console.log("信用卡有效期：", validate);
        return validate;
      }
    },
    //获取成本中心list
    GetCostCenterList() {
      console.log(this.dataForm);
      if(this.dataForm.contact.userId=="" || this.dataForm.contact.userId==undefined || this.dataForm.contact.userId==null)
      {
        return;
      }
      let Params = {
        params: {
          customerCode: this.$objBaseInfo.customerCode,
          agentId: this.dataForm.contact.userId,
          gustId: this.dataForm.traveler.userId,
          type: this.costCenterType,
        },
      };
      let that=this;
      this.CostCenterList=[];
      this.dataForm.costCenterid=0;
      this.dataForm.uatpCardNo="";
      this.dataForm.uatpCardValidDate="";
      this.dataForm.supplierAndModel="";
      getCostCenter(Params)
        .then((res) => {
          if (res.code == 200) {
            let arr=res.data;
            that.CostCenterList=arr;
            if(Object.prototype.hasOwnProperty.call(that.$objBaseInfo,"posCostCenterModel"))
            {
              let posCostCenterModel=that.$objBaseInfo.posCostCenterModel;
              if(posCostCenterModel.isopen==0)
              {
                return;//代表关闭成本中心
              }
              if(posCostCenterModel.isselect==0)//代表默认选中 不可更改
              {
                that.isCostCenterEdit=true;
              }
              else
              {
                //可以更改
                that.isCostCenterEdit=false;
              }
              if(arr.length>0)
              {
                if(that.manualOrderListCostCenterid){
                    // 查找id等于manualOrderListCostCenterid的那条数据
                    const matched = that.CostCenterList.find(p => p.id == that.manualOrderListCostCenterid);
                    if (matched) {
                      that.costCenteroptions = [matched];
                      that.dataForm.costCenterid = matched.id;
                      that.dataForm.uatpCardNo = matched.uatpno;
                    } else {
                      that.costCenteroptions = that.CostCenterList.slice(0, 1);
                      that.dataForm.costCenterid = arr[0].id;
                      that.dataForm.uatpCardNo = arr[0].uatpno;
                    }
                }else{
                  that.costCenteroptions = that.CostCenterList.slice(0,1);
                  that.dataForm.costCenterid= arr[0].id;
                  that.dataForm.uatpCardNo=arr[0].uatpno;
                }
              }
              else//判断是否存在有可供选择的成本中心
              {
                that.confirmFlag = true;
                that.confirmMsg =that.$t("BOOKING.CostCenterTitle2");
                return;
              }
              if(posCostCenterModel.isuatp==1)
              {
                if(that.dataForm.uatpCardNo=="")
                {
                  that.confirmFlag = true;
                  that.confirmMsg =that.$t("BOOKING.CostCenterUATPTitle1");
                }
                else
                {
                  that.GetUATPDetails();//调用获取成本中心有效期方法
                }
              }
              else
              {
                if(that.dataForm.uatpCardNo!="")
                {
                  that.GetUATPDetails();//调用获取成本中心有效期方法
                }
              }
            }
          }
          else
          {
            that.confirmFlag = true;
            that.confirmMsg =that.$t("BOOKING.CostCenterTitle2");
          }
        })
        .catch(function (error) {
          that.confirmFlag = true;
          that.confirmMsg =that.$t("BOOKING.CostCenterTitle2");
        });
    },
    CostCenterloadMore(val){
      // val是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
      // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
      if(this.costCenterrangeNumber>this.CostCenterList.length)
      {
        return;
      }
      return () => (this.costCenterrangeNumber += 50); // 每次滚动到底部可以新增条数  可自定义
    },
     // 筛选方法
    filterMethod:_debounce(function(filterVal){
      if(filterVal){
        let filterArr = this.CostCenterList.filter((item)=>{
          return item.costName.includes(filterVal)
        })
        this.costCenteroptions = filterArr;
      }else{
        this.costCenteroptions = this.CostCenterList;
      }
    },500),
    // 下拉框出现时，调用过滤方法
    visibleChange(flag){
      if(flag){
        this.filterMethod()
      }
    },
    checkIsOpenOtherGuest(){
      if(this.dataForm.isShowOtherGuest && (this.dataForm.settlementMethod=="3" || this.dataForm.paymentStatus=="4")){
        this.confirmFlag = true;
        this.confirmMsg = this.$t("MANUAL.VALIDATEOTHERGUESTPAYMENT");
      }
    },
    showOtherGuest(){
      this.dataForm.isShowOtherGuest = !this.dataForm.isShowOtherGuest
      this.checkIsOpenOtherGuest();
    },
    openManualOrderList(){
      this.manualOrderInfo.manualDialog = true;
    },
    handleDialogClosed() {
      this.manualOrderInfo.manualDialog = false;
    },
    openConfirmFlag(message){
      this.confirmFlag = true;
      this.confirmMsg = message;
    },
    async selectManualOrder(row){
      this.manualOrderInfo.manualDialog = false;
      this.manualOrderInfo.manualCode = row.manualCode;
      var data = JSON.parse(row.valueInfo);
      this.dataForm = data;
      this.dataForm.BookingCodeManualOrder="";
      this.selectHotelName="";
      this.selectRoomTypeName="";
      this.selectCityName="";
      this.dataForm.clientOrderNo="";
      this.manualOrderListCostCenterid ="";
      if (data.hotel.hasOwnProperty("selectHotelName")) 
      {
          this.selectHotelName=data.hotel.selectHotelName;
      }
      if (data.roomType.hasOwnProperty("selectRoomTypeName")) 
      {
          this.selectRoomTypeName=data.roomType.selectRoomTypeName;
      }
      if (data.city.hasOwnProperty("selectCityName")) 
      {
          this.selectCityName=data.city.selectCityName;
      }
      if (row.hasOwnProperty("bookingCode")) 
      {
          this.dataForm.BookingCodeManualOrder=row.bookingCode;
      }
      if (row.hasOwnProperty("clientOrderNo")) 
      {
          this.dataForm.clientOrderNo=row.clientOrderNo;
      }
      if (this.dataForm.hotel.hotelName != '' || this.dataForm.roomType.roomTypeCode) 
      {
          await this.getRoomTypeList(true)
      }
      if(data.channel=="-1")
      {
        this.channelDialogInfo.channelValue=data.channelValue;
      }
      if (row.hasOwnProperty("createBy")) 
      {
        this.ManualOrderCreate=row.createBy;
      }
      if (row.hasOwnProperty("createUserId")) 
      {
        this.ManualOrderCreateUserId=row.createUserId;
      }
      if (data.hasOwnProperty("costCenterid")) 
      {
        this.manualOrderListCostCenterid = data.costCenterid;
      }

      this.clientDialogInfo.selectedCustomerCode = data.customer.customerId;
      //替换全局的customerCode 、userCode、tc小组信息
      this.$objBaseInfo.userCode = data.customer.customerId;
      this.$objBaseInfo.customerCode = data.customer.customerId;
      //this.$objBaseInfo.customerTcs = item.customerTcs;
      //获取poscode
      await this.getPointSale(data.customer.customerId,data.isShowOtherGuest);
      //获取MI信息
      await this.getMiList();
      // 根据view权限获取员工信息
      await this.getTraveler(1);
      this.customerCodeChoosen = data.customer.customerId;
      //this.getCharges();
      if(data.city.destinationType == "I"|| this.provinceCode.indexOf(data.city.provinceCode) >-1)
      {
        this.showTaxes = true;
        this.chargeType = "20";
      }
      else{
        this.showTaxes = false;
        this.chargeType = "3";
      }
      await this.getCountryList(data.city.countryCode);
      await this.LoadCostCenter();
    },
    async saveManualInfo(bookingCode) {
      const form = this.$refs.dataForm;
      if (!form) {
        return false;
      }
      const fieldList = [
        "customer.customerName",
        "contact.contactName",
        "contact.contactMobile",
        "contact.contactEmail",
        "traveler.travelerName",
        "traveler.mobile",
        "traveler.email",
        "city.cityName",
        "checkinDate",
        "checkOutDate",
      ];
      try {
        await form.validateField(fieldList);
      } catch (error) {
        return false;
      }

      this.dataForm.channelValue = this.channelDialogInfo.channelValue;
      const params = {
        customerID: this.dataForm.customer.customerId,
        customerName: this.dataForm.customer.customerName,
        contactName: this.dataForm.contact.contactName,
        contactTel: this.dataForm.contact.contactMobile,
        contactEmail: this.dataForm.contact.contactEmail,
        guestName: this.dataForm.traveler.travelerName,
        guestTel: this.dataForm.traveler.mobile,
        guestEmail: this.dataForm.traveler.email,
        cityCode: this.dataForm.city.cityCode,
        cityName: this.dataForm.city.cityName,
        checkInDate: formatDateTime(this.dataForm.checkinDate,"YYYY-MM-DD"),
        CheckOutDate: formatDateTime(this.dataForm.checkOutDate,"YYYY-MM-DD"),
        valueInfo: JSON.stringify(this.dataForm),
        manualCode: this.manualOrderInfo.manualCode,
        hotelNameCn:this.dataForm.hotel.hotelName,
        hotelNameEn:this.dataForm.hotel.hotelNameEN,
      };
      if (bookingCode) {
        params.bookingCode = bookingCode;
      }

      try {
        const res = await saveManual(params);
        const saved = res.code == 200 && res.data && res.data.status;
        if (!saved) {
          this.confirmFlag = true;
          this.confirmMsg = "保存失败";
          return false;
        }

        if (!bookingCode) {
          this.resetPage();
          this.confirmFlag = true;
          this.confirmMsg = "保存成功";
        }
        return true;
      } catch (error) {
        this.confirmFlag = true;
        this.confirmMsg = "保存失败";
        return false;
      }
    },
    // 页面重置方法
    resetPage() {
      // 重置 dataForm 数据
      this.dataForm = this.$options.data().dataForm;

      // 重置其他相关数据
      this.hotelDialogInfo.searchHotelName = "";
      this.hotelDialogInfo.searchStarRating = "";
      this.hotelDialogInfo.searchContactTel = "";
      this.clientDialogInfo.selectedCustomerCode = "";
      this.employeeDialogInfo.searchTel = "";
      this.employeeDialogInfo.searchName = "";
      this.channelDialogInfo.channel = "";
      this.channelDialogInfo.channelValue = "";
      this.manualOrderInfo.manualCode = "";
      this.miList = [];
      
      // 重置表单验证状态
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
      });
    },
    ChangeGuest(){
      // 清空出生日期
      if(this.changeGuestCheckBox){
        this.dataForm.traveler.showIdNumber = true;
        this.dataForm.bookingFormOther.showIdNumber = true;
        this.dataForm.traveler.isTemporary = true;
        this.dataForm.bookingFormOther.isTemporary = true;
        this.dataForm.traveler.lKPKID = 0;
        this.dataForm.bookingFormOther.lKPKID = 0;
        this.dataForm.traveler.RefId = this.dataForm.contact.RefId;
        this.dataForm.traveler.userId = this.dataForm.contact.userId;
        this.dataForm.bookingFormOther.travelerCode = this.dataForm.contact.userId;
        this.dataForm.bookingFormOther.refId = this.dataForm.contact.RefId;
      }else{
        this.dataForm.traveler.showIdNumber = false;
        this.dataForm.traveler.travelerName = "";
        this.dataForm.traveler.mobile = "";
        this.dataForm.traveler.email = "";
        this.dataForm.bookingFormOther.showIdNumber = false;
        this.dataForm.bookingFormOther.name = "";
        this.dataForm.bookingFormOther.mobile = "";
        this.dataForm.bookingFormOther.email = "";
      }
      this.dataForm.traveler.birthday="";
      this.dataForm.bookingFormOther.birthday="";
      this.dataForm.traveler.idCardNumber="";
      this.dataForm.bookingFormOther.idCardNumber="";
      this.dataForm.traveler.passportNumber="";
      this.dataForm.bookingFormOther.passportNumber="";

      this.dataForm.traveler.visaCountry="";
      this.dataForm.bookingFormOther.visaCountry="";

      this.dataForm.traveler.sex="";
      this.dataForm.bookingFormOther.sex="";
      this.changeGuestCheckBox = !this.changeGuestCheckBox
    },
    async getHotelOrder(hotelCode,orderNumber){
      let orderParam = {
        params: {
          hotelCode: hotelCode,
          orderNumber:orderNumber
        },
      };
      await getHotelOrderInfo(orderParam)
        .then((res) => {
          if(res.code == 200){
            this.copyOrderListInfo = res.data;
            if(res.data.city){
              getCityInfoByCode(res.data.city.cityCode).then((city) => {
                if (city) {
                  this.dataForm.city = city;
                }
              });
            }
          }
        });
    },
    initializationInfo(){
      if(this.searchParm != ''){
        var parm = JSON.parse(this.searchParm);
        this.dataForm.city = parm.city;
        this.dataForm.checkinDate = parm.checkInAt;
        this.dataForm.checkOutDate = parm.checkOutAt;
        this.clientDialogInfo.selectedCustomerCode = parm.userCode;
        this.employeeDialogInfo.searchTel = parm.mobilePhone;//查询联系人所需电话
        this.employeeDialogInfo.searchName = parm.loginName;//查询联系人所需姓名
        this.destinationType = parm.city.destinationType;
        if(parm.city.destinationType == "I"|| this.provinceCode.indexOf(parm.city.provinceCode) >-1)
        {
          this.showTaxes = true;
          this.chargeType = "20";
        }
        else{
          this.showTaxes = false;
          this.chargeType = "3";
        }
        if(parm.userCode != ""){
          this.$objBaseInfo.poscode = parm.userCode;
          this.getCustomerList().then(() => {
            this.selectClient(this.customerDetails);
            this.getTraveler(1).then(() => {
              if(this.employeeDialogInfo.employeeData.length >0 && parm.loginName !=""){
                this.selectTraveler(this.employeeDialogInfo.employeeData[0]);
              }
            });
          })
        }
        if(parm.hotelId !=""){
          this.hotelDialogInfo.hotelCode = parm.hotelId;//查询酒店需要的参数
          this.getHotelList(1,true).then(() => {
            if(this.hotelDialogInfo.hotelData.length >0){
              this.selectHotel(this.hotelDialogInfo.hotelData[0]);
            }
          })
        }
      }
      if(this.$route.query.orderId != undefined){
        this.getHotelOrder(null,this.$route.query.orderId).then(() => {
          //订单信息
          this.dataForm.city = this.copyOrderListInfo.city;
          this.dataForm.checkinDate = this.copyOrderListInfo.checkinDate;
          this.dataForm.checkOutDate = this.copyOrderListInfo.checkOutDate;
          this.dataForm.paymentStatus = this.copyOrderListInfo.paymentStatus;
          this.dataForm.priceType = this.copyOrderListInfo.priceType;
          this.dataForm.settlementMethod = this.copyOrderListInfo.settlementMethod;
          this.dataForm.rateAccessCode = this.copyOrderListInfo.rateAccessCode;
          this.dataForm.costCenterid = this.copyOrderListInfo.costCenterid;
          this.dataForm.approvedTrips = this.copyOrderListInfo.approvedTrips;
          //预订人信息
          this.dataForm.customer.customerId = this.copyOrderListInfo.customer.customerId;
          this.dataForm.customer.customerName = this.copyOrderListInfo.customer.customerName;
          this.clientDialogInfo.selectedCustomerCode = this.copyOrderListInfo.customer.customerId;
          this.dataForm.contact.contactName = this.copyOrderListInfo.contact.contactName;
          this.dataForm.contact.contactMobile = this.copyOrderListInfo.contact.contactMobile;
          this.dataForm.contact.contactEmail = this.copyOrderListInfo.contact.contactEmail;
          this.dataForm.contact.userId = this.copyOrderListInfo.contact.userId;
          this.employeeDialogInfo.searchTel = this.copyOrderListInfo.contact.contactMobile;
          this.employeeDialogInfo.searchName = this.copyOrderListInfo.contact.contactName;
          this.$objBaseInfo.poscode = this.copyOrderListInfo.customer.customerId;
          this.getCustomerList().then(() => {
            this.selectClient(this.customerDetails);
            this.getTraveler(1).then(() => {
              this.dataForm.servicefee = this.copyOrderListInfo.servicefee;
              this.dataForm.urgentFee = this.copyOrderListInfo.urgentFee;
              this.dataForm.advancePayment = 0;//清空订单里的垫资费this.copyOrderListInfo.advancePayment;
              if(this.dataForm.settlementMethod == "3"){
                if(this.dataForm.orderStatus == 'BOOKED'){
                  this.validateHotelNo = true;
                }
                this.showAdvancepayment = true;
              }
              if(this.employeeDialogInfo.employeeData.length >0){
                this.selectTraveler(this.employeeDialogInfo.employeeData[0]);
              }
            });
          })
          //酒店信息
          this.hotelDialogInfo.hotelCode = this.copyOrderListInfo.hotel.hotelCode;//查询酒店需要的参数
          this.getHotelList(1,true).then(() => {
            if(this.hotelDialogInfo.hotelData.length >0){
              this.selectHotel(this.hotelDialogInfo.hotelData[0]).then(() => {
                this.dataForm.hotelType = this.copyOrderListInfo.hotelType;
                this.dataForm.breakfast = this.copyOrderListInfo.breakfast;
                this.dataForm.roomType = this.copyOrderListInfo.roomType;
                this.dataForm.smoking = this.copyOrderListInfo.smoking;
                this.dataForm.channel = this.copyOrderListInfo.channel;
                this.channelDialogInfo.channelValue = this.copyOrderListInfo.channelValue;
                this.dataForm.currencyCode = this.copyOrderListInfo.currencyCode;
                this.dataForm.arrivalTimeInfo = this.copyOrderListInfo.arrivalTimeInfo;
                this.dataForm.prices.totalPrice = this.copyOrderListInfo.totalPrice;
                this.dataForm.prices.dailyPricesDateData = this.copyOrderListInfo.roomStay;
                this.setDailyPricesDateData();
                if(this.copyOrderListInfo.roomStay){
                  for (const key in this.dataForm.prices.dailyPricesDateData) {
                    const element = this.dataForm.prices.dailyPricesDateData[key];
                    this.dataForm[element] = this.copyOrderListInfo.roomStay[key]["price"];
                  }
                }
                this.savePriceDetails();
              });
            }
          })
          //担保政策信息
          this.dataForm.guaranteeType = this.copyOrderListInfo.guaranteeType;
          this.dataForm.cancellationRules = this.copyOrderListInfo.cancellationRules;
        });
      }
    },
    orderStatusChange(){
      this.validateHotelNo = false;
      this.orderStatus_Failed = true;
      if(this.dataForm.orderStatus == 'BOOKING_FAILED'){
        this.validateHotelNo = false;
        this.orderStatus_Failed = false;
      }else{
        if(this.dataForm.settlementMethod == "3"){
          this.validateHotelNo = true;
        }
      }
    },
    validateDailyPrices(rule, value, callback) {
      if(this.dataForm.orderStatus == 'BOOKING_FAILED'){
        callback();
      }else{
        if (this.dataForm.prices.dailyPrices.length === 0 || this.dataForm.prices.dailyPrices.length !== this.dataForm.prices.dailyPricesDateData.length) {
          // 如果满足条件，则设置错误信息
          callback(new Error(this.$t("MANUAL.VALIDATEDAILYPRICES")));
        } else {
          // 否则，验证通过
          callback();
        }
      }
    },
    //获取搜索下拉值-国省市
    async getCountryList(countryCode) {
      let searchparams = {
        params: {
          countryCode: countryCode,
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          if(res.code==200 && res.data.list.length > 0){
            this.$objBaseInfo.intlTaxDisplay = res.data.list[0].intlTaxDisplay;
          }
        });
    },
    openCardTypeDialog(){
      this.selectedCardType = this.dataForm.traveler.cardType;
      this.dialogValue = true;
    },
    openOtherCardTypeDialog(){
      this.selectedOtherCardType = this.dataForm.bookingFormOther.cardType;
      this.dialogOtherValue = true;
    },
    cancelCardTypeDialog(){
      this.dialogValue = false;
    },
    cancelCardTypeOtherDialog(){
      this.dialogOtherValue = false;
    },
    handleCardTypeSubmit(value){
      this.dataForm.traveler.cardTypeSelectDisabled = true;
      this.dataForm.traveler.cardTypeButtonDisabled = true;
      this.dataForm.traveler.cardTypeNumber = value.certificateNumber;
      this.dataForm.traveler.cardType = value.certificateType;
      this.dataForm.traveler.passportNumber = value.certificateType;
      this.dataForm.traveler.idCardNumber = value.certificateNumber;
      if(value.certificateType=="NI" || value.certificateType=="GATJZZ"){
        return;
      }
      this.dataForm.traveler.birthday = value.birthDate;
      this.dataForm.traveler.sex = value.gender;
      this.dataForm.traveler.visaCountry = value.issuingCountryCode;
    },
    handleCardTypeOtherSubmit(value){
      this.dataForm.bookingFormOther.cardTypeSelectDisabled = true;
      this.dataForm.bookingFormOther.cardTypeButtonDisabled = true;
      this.dataForm.bookingFormOther.cardTypeNumber = value.certificateNumber;
      this.dataForm.bookingFormOther.cardType = value.certificateType;
      this.dataForm.bookingFormOther.passportNumber = value.certificateType;
      this.dataForm.bookingFormOther.idCardNumber = value.certificateNumber;
      if(value.certificateType=="NI" || value.certificateType=="GATJZZ"){
        return;
      }
      this.dataForm.bookingFormOther.birthday = value.birthDate;
      this.dataForm.bookingFormOther.sex = value.gender;
      this.dataForm.bookingFormOther.visaCountry = value.issuingCountryCode;
    },
    disabledDate(time) {
      return time.getTime() > Date.now()
    },
  },
  directives:{
      'el-select-loadmore': {
      inserted(el, binding) {
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        if (!SELECTWRAP_DOM) return;

        // 防抖函数：避免频繁触发
        const debounceFn = debounce((e) => {
          const { scrollHeight, scrollTop, clientHeight } = e.target;
          // 添加 1px 容错范围，避免精度问题
          if (scrollHeight - (scrollTop + clientHeight) <= 1) {
            binding.value();
          }
        }, 200);

        // 保存防抖函数和元素引用，用于解绑
        SELECTWRAP_DOM._debounceScroll = debounceFn;
        SELECTWRAP_DOM.addEventListener('scroll', SELECTWRAP_DOM._debounceScroll);
      },
      unbind(el) {
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        if (SELECTWRAP_DOM && SELECTWRAP_DOM._debounceScroll) {
          // 移除监听器并清理引用
          SELECTWRAP_DOM.removeEventListener('scroll', SELECTWRAP_DOM._debounceScroll);
          delete SELECTWRAP_DOM._debounceScroll;
        }
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
.center_sty {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
}

.row_sty {
  margin: 1.3rem !important;
  border-bottom: 0.2rem solid #fc6640;
  padding-bottom: 0.9rem;
}

.btn_sty {
  padding: 0.4rem;
  float: right;
  margin-top: -2.6rem;
  margin-right: 1rem;
  border-radius: 0;
  color: #fc6640;
  background-color: #fff;
  border-color: #fc6640;
}

#nav2 {
  background-color: #ffffff;
  padding-bottom: 1rem;
}

.grey_small_font {
  height: 20px;
  font-size: 14px;
  font-family: sans-serif;
  color: #6f787e;
}

.grid-content {
  margin-top: 1rem;
}

.myinput_inner :deep(.el-input__inner) {
  height: 2.7rem;
  border-radius: 0;
  width: 80%;
}

.biginput_inner :deep(.el-input__inner) {
  height: 5.4rem;
  border-radius: 0;
  width: 84%;
}

.myselect_inner :deep(.el-input__inner) {
  height: 2.7rem;
  border-radius: 0;
}

.mytime_inner :deep(.el-input__inner) {
  height: 2.7rem;
  width: 100%;
  border-radius: 0;
}

.timeicon_inner :deep(.el-input__icon) {
  margin-top: 0.5rem;
}

.content_size {
  margin: 0.9rem !important;
  padding-bottom: 1rem !important;
}

::v-deep .el-select {
  width: 80%;
}

.submit-btn {
  height: 5rem;
  width: 17.6rem;
  border-radius: 3px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 80%;
}

::v-deep .el-input__inner {
  height: 2.7rem;
  line-height: 2.7rem;
}

::v-deep .el-input__icon {
  height: 2.7rem;
  line-height: 2.7rem;
}

#nav5 :deep(.el-input__icon) {
  line-height: 25px;
}

::v-deep .el-checkbox__input {
  vertical-align: top;
  padding-top: 0.4rem;
}

::v-deep .el-checkbox__label {
  white-space: pre-wrap;
  padding-left: 5px;
}

::v-deep .dialog-one .el-dialog__header, ::v-deep .dialog-one .el-tabs__active-bar {
  display: none;
}

::v-deep .dialog-one .el-dialog__body {
  padding: 0px;
}

::v-deep .el-tabs__item {
  padding: 0px 10px;
}

::v-deep .el-tabs__item.is-active {
  background: $tab-color-active;
  color: #000;
  margin-bottom: 2px;
  padding-right: 10px;
}

::v-deep .el-tabs__item.is-top:nth-child(2) {
  padding-left: 10px;
}

::v-deep .el-tabs__item.is-top:last-child {
  padding-right: 10px;
}

::v-deep el-tabs__item {
  text-align: center;
  font-size: 14px;
  /* font-weight: 600; */
}

::v-deep .el-tabs__nav-wrap {
  position: unset;
  pointer-events: auto;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: $btn-bg-color;
  width: 100%;
}

.add-guest-div {
  position: absolute;
  top: 15px;
  right: 40px;
  z-index: 1000;
}

.add-guest-btn {
  padding: 8px 13px;
  background-color: $btn-bg-color;
  color: $btn-font-color;
  pointer-events: auto;
}

.search-input {
  margin-left: 10%;
}

.search-btn {
  margin: 2% 5%;

  button {
    padding: 7px 20px;
    border: 1px solid $btn-bg-color;
    color: $btn-bg-color;
  }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: $btn-bg-color;
}

::v-deep .el-tabs__header {
  pointer-events: none;
}

.el-select-dropdown ul, .el-select-dropdown li {
  padding: 0px 10%;
  padding-left: 1rem;
}

.dialog-footer {
  text-align: center;
}

.dialog-footer button {
  padding: 2% 10%;
  border: 1px solid $btn-bg-color;
}

.dialog-footer .search-btn {
  background-color: $btn-bg-color;
}

.dialog-two {
  ::v-deep .el-dialog__body {
    padding: 3rem 0px 0px 0px;
  }

  .title-divider {
    margin-top: -1.5rem;
    height: 2px;
    background-color: $btn-bg-color;
  }
}

.select-btn {
  color: $btn-bg-color;
  cursor: pointer;
}

.dialog-form-row {
  margin: 1rem auto;
}

.dialog-form-row :deep(.el-input__inner) {
  width: 23rem;
}

.form-label-field {
  ::v-deep .el-form-item__label {
    font-size: 1.4rem;
    height: 2rem;
    line-height: 2rem;
    margin-top: 1rem;
    color: $text-fill-color;
  }
}

.el-form--inline .el-form-item {

  line-height: 2.7rem;
  width: 100%;
}

.dialog-two :deep(.el-form--inline .el-form-item) {
  height: 5rem;
  line-height: 2.7rem;
  width: 100%;
}

.pricesDetailsPopover {
  .title {
    line-height: 3rem;
    border-bottom: 0.2rem solid #fc6640;
  }

  .title p {
    font-size: 16px;
    font-weight: 700;
  }

  table {
    white-space: nowrap;
    overflow-x: auto;
    display: block;
  }

  table td {
    line-height: 4rem;
    width:10px;
  }

  .dialog-footer {
    padding-top: 1rem;
  }

  a {
    font-size: 16px;
    font-weight: 700;
    text-decoration: none;
    cursor: pointer;
    color: #1061CC;
  }
}
.hotelAddress :deep(.el-form-item__content) {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.miNoteFont{
  color:rgb(111, 120, 126);
  font-size:1.4rem;
}
.miNoteFontT{
  cursor:pointer;
  text-decoration:underline;
}
.miNoteFontF{
  cursor:default;
  text-decoration:none;
}
.colorRed{
  color:red;
  font-size:1.2rem;
  position: absolute;
  top: -3.4rem;
  left: 9rem;
}
::v-deep .el-form-item__content .el-input-group{
  vertical-align: revert;
}
::v-deep .el-input-group__append{
  border-radius: 0;
}
::v-deep .el-input__inner{
  border-radius: 0;
}
.editCardTypeButtonStyle{
  white-space: nowrap;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  background-color: rgb(252, 102, 64);
  color: #fff;
  border: 0px;
  border-radius: 0.3rem;
  width: 10rem;
}
.syncBtn{
  width: 15%;
  height: 2.7rem;
  line-height: 2.7rem;
  background-color: #fc6640;
  color: #fff;
  border: 0px;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 0.3rem;
  font-family: Source-Sans-Bold;
}
</style>